import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { BASE_URL, DEFAULT_TEMPERATURE, PAGINATION } from '../../config';
import rrwebPlayer from "rrweb-player";
import "rrweb-player/dist/style.css";
import JSZip from 'jszip';
import { buildUtahBackfillParams, utahBackfillError } from './utahBackfillContract';
import { UtahProviderTarget, UtahBackfillResult } from './UtahBackfill';
import { UHC_BACKFILL_JOB_TYPE, buildUhcBackfillParams, uhcBackfillError, uhcCreateError } from './uhcBackfillContract';
import { UhcBackfillFields, UhcBackfillResult } from './UhcBackfill';
import { OPTUM_BACKFILL_JOB_TYPE, buildOptumBackfillParams, optumBackfillError, optumCreateError } from './optumBackfillContract';
import { OptumBackfillFields, OptumBackfillResult } from './OptumBackfill';

const Card = ({ children, className = "" }) => (
  <div className={`bg-white rounded-lg border border-gray-200 ${className}`}>
    {children}
  </div>
);

const Button = ({ children, onClick, className = "", disabled = false }) => (
  <button
    className={`px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors ${
      disabled ? 'opacity-50 cursor-not-allowed' : ''
    } ${className}`}
    onClick={onClick}
    disabled={disabled}
  >
    {children}
  </button>
);

const TryItOut = () => {
  const [pageSize] = useState(PAGINATION.pageSize);
  const [offset, setOffset] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [newPrompt, setNewPrompt] = useState('');
  const [temperature, setTemperature] = useState(DEFAULT_TEMPERATURE);
  const [selectedCookie, setSelectedCookie] = useState('');
  const [depositCookies, setDepositCookies] = useState(false);
  const [availableCookies, setAvailableCookies] = useState([]);
  const [cookieSearchQuery, setCookieSearchQuery] = useState('');
  const [advancedBrowserSettings, setAdvancedBrowserSettings] = useState(false);
  const [scouts, setScouts] = useState([]);
  const [customScripts, setCustomScripts] = useState([]);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [selectedScout, setSelectedScout] = useState(null);
  const [selectedScript, setSelectedScript] = useState(null);
  const [activeTab, setActiveTab] = useState('details');
  const [activeTableTab, setActiveTableTab] = useState('scouts');
  const [activeCreateTab, setActiveCreateTab] = useState('scout');
  const [newScript, setNewScript] = useState('');
  const [requirementsTxt, setRequirementsTxt] = useState('');
  const [pollingIntervals, setPollingIntervals] = useState({});
  const [activeUrlTab, setActiveUrlTab] = useState(0);
  const [urls, setUrls] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [recording, setRecording] = useState(null);
  const [player, setPlayer] = useState(null);
  const [isExampleModalOpen, setIsExampleModalOpen] = useState(false);
  const [isApiDocsModalOpen, setIsApiDocsModalOpen] = useState(false);
  const [scrapers835, setScrapers835] = useState([]);
  const [selectedPayer, setSelectedPayer] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [corporateId, setCorporateId] = useState('');
  const [siteId, setSiteId] = useState('');
  const [backfills835, setBackfills835] = useState([]);
  const [utahDomainValue, setUtahDomainValue] = useState('');
  const [uhcCreateErrorMessage, setUhcCreateErrorMessage] = useState('');
  const [isCreatingUhc, setIsCreatingUhc] = useState(false);
  const uhcSubmissionInFlight = useRef(false);
  const [optumLoginId, setOptumLoginId] = useState('');
  const [optumCreateErrorMessage, setOptumCreateErrorMessage] = useState('');
  const [isCreatingOptum, setIsCreatingOptum] = useState(false);
  const optumSubmissionInFlight = useRef(false);
  const [selectedBackfillPortal, setSelectedBackfillPortal] = useState('ECW');
  const [websiteUrl, setWebsiteUrl] = useState('');
  const [initialPage, setInitialPage] = useState('');
  const [numPages, setNumPages] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  
  const { apiKey } = useAuth();

  const handleScriptDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      const file = e.dataTransfer.files[0];
      if (file.name.endsWith('.py')) {
        const reader = new FileReader();
        reader.onload = (event) => {
          setNewScript(event.target.result);
        };
        reader.readAsText(file);
      }
    }
  };
  
  const handleRequirementsDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      const file = e.dataTransfer.files[0];
      if (file.name === 'requirements.txt') {
        const reader = new FileReader();
        reader.onload = (event) => {
          setRequirementsTxt(event.target.result);
        };
        reader.readAsText(file);
      }
    }
  };
  
  const preventDefault = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  useEffect(() => {
    if (activeTableTab === 'scouts') {
      fetchScouts();
    } else if (activeTableTab === 'scripts') {
      fetchCustomScripts();
    } else if (activeTableTab === '835scrapers') {
      fetch835Scrapers();
    } else if (activeTableTab === '835backfills') {
      fetch835Backfills();
    }
    if (isCreateModalOpen) {
      fetchAvailableCookies();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [offset, pageSize, isCreateModalOpen, activeTableTab]);

  const hasActiveBackfillJob = backfills835.some(job =>
    ['utah_medicaid_835_backfill', UHC_BACKFILL_JOB_TYPE, OPTUM_BACKFILL_JOB_TYPE].includes(job.job_type) && ['PENDING', 'QUEUED', 'RUNNING'].includes(job.status));

  useEffect(() => {
    if (activeTableTab !== '835backfills' || isCreateModalOpen || !hasActiveBackfillJob) return;
    let refreshing = false;
    const interval = setInterval(async () => {
      if (refreshing) return;
      refreshing = true;
      try { await fetch835Backfills(true); } finally { refreshing = false; }
    }, 15000);
    return () => clearInterval(interval);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTableTab, isCreateModalOpen, hasActiveBackfillJob, offset, pageSize, apiKey?.key]);

  const fetchScouts = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await fetch(`${BASE_URL}/scout/list?limit=${pageSize}&offset=${offset}`, {
        headers: {
          'Authorization': `Bearer ${apiKey.key}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setScouts(data);
        setTotalCount(data.length);
      } else {
        const errorData = await response.json();
        setError(typeof errorData.detail === 'string' ? errorData.detail : 'Failed to fetch Scout sessions');
      }
    } catch (error) {
      console.error('Error fetching Scout sessions:', error);
      setError('Failed to fetch Scout sessions. Please check your connection.');
    } finally {
      setIsLoading(false);
    }
  };

  const fetchAvailableCookies = async () => {
    try {
      const response = await fetch(`${BASE_URL}/scout/cookies`, {
        headers: {
          'Authorization': `Bearer ${apiKey.key}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setAvailableCookies(data);
      }
    } catch (error) {
      console.error('Error fetching cookies:', error);
    }
  };

  const fetchRecording = async (id, type = 'scout') => {
    try {
      // Clean up existing player if any
      if (player) {
        const replayer = player.getReplayer();
        if (replayer) {
          replayer.pause();
          replayer.destroy();
        }
        setPlayer(null);
      }

      const response = await fetch(`${BASE_URL}/scout/${id}/get-recording/${type}`, {
        headers: {
          'Authorization': `Bearer ${apiKey.key}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setRecording(data);
        
        // Wait for DOM to be ready and get the correct recording player element
        setTimeout(() => {
          const playerId = type === 'custom' ? 'recording-player-script' : 'recording-player-scout';
          const targetElement = document.getElementById(playerId);
          
          if (!targetElement) {
            console.error(`Recording player element not found: ${playerId}`);
            return;
          }

          // Clear any existing content
          targetElement.innerHTML = "";
          
          try {
            // Initialize new player
            const newPlayer = new rrwebPlayer({
              target: targetElement,
              props: {
                events: data,
                width: 800,
                height: 600,
                skipInactive: false,
                showController: true,
                autoPlay: true,
              },
            });
            
            setPlayer(newPlayer);
            console.log('Recording player initialized successfully');
          } catch (playerError) {
            console.error('Error initializing rrweb player:', playerError);
            targetElement.innerHTML = '<p class="text-red-600 p-4">Error loading recording player</p>';
          }
        }, 100); // Small delay to ensure DOM is ready
      } else {
        console.error('Failed to fetch recording');
        setRecording(null);
      }
    } catch (error) {
      console.error('Error fetching recording:', error);
      setRecording(null);
    }
  };

  const fetchCustomScripts = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await fetch(`${BASE_URL}/scout/custom-scripts?limit=${pageSize}&offset=${offset}`, {
        headers: {
          'Authorization': `Bearer ${apiKey.key}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setCustomScripts(data);
        setTotalCount(data.length);
      } else {
        const errorData = await response.json();
        setError(typeof errorData.detail === 'string' ? errorData.detail : 'Failed to fetch custom scripts');
      }
    } catch (error) {
      console.error('Error fetching custom scripts:', error);
      setError('Failed to fetch custom scripts. Please check your connection.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleCreateScout = async () => {
    try {
      const response = await fetch(`${BASE_URL}/scout/`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${apiKey.key}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          user_prompt: newPrompt,
          operator_controller_type: "RCM_OPS_TWO_FACTOR_AUTH",
          temperature: temperature,
          cookie_name: selectedCookie || undefined,
          deposit_cookies: depositCookies,
          advanced_browser_settings: advancedBrowserSettings
        })
      });

      if (response.ok) {
        setIsCreateModalOpen(false);
        setNewPrompt('');
        setTemperature(DEFAULT_TEMPERATURE);
        setSelectedCookie('');
        setDepositCookies(false);
        setAdvancedBrowserSettings(false);
        fetchScouts();
      }
    } catch (error) {
      console.error('Error creating Scout session:', error);
    }
  };

  const handleViewScout = (scout) => {
    setSelectedScout(scout);
    setIsViewModalOpen(true);
    setActiveTab('details');
    setUrls(scout.urls || []);
    setRecording(null);
    if (scout.status === 'IN_PROGRESS') {
      startPolling(scout.id);
    } else if (scout.status === 'COMPLETED' || scout.status === 'ERROR') {
      fetchRecording(scout.id);
    }
  };

  const startPolling = (id) => {
    if (pollingIntervals[id]) {
      clearInterval(pollingIntervals[id]);
    }

    const interval = setInterval(() => pollScoutStatus(id), 10000);
    setPollingIntervals(prev => ({
      ...prev,
      [id]: interval
    }));
  };

  const closeCreateScoutModal = () => {
    setUhcCreateErrorMessage('');
    setOptumCreateErrorMessage('');
    setIsCreateModalOpen(false);
    setNewPrompt('');
    setTemperature(DEFAULT_TEMPERATURE);
    setSelectedCookie('');
    setDepositCookies(false);
    setAdvancedBrowserSettings(false);
    // Reset 835 backfill fields
    setUsername('');
    setPassword('');
    setSiteId('');
    setWebsiteUrl('');
    setInitialPage('');
    setNumPages('');
    setCorporateId('');
    setFromDate('');
    setToDate('');
    setSelectedBackfillPortal('ECW');
    setUtahDomainValue('');
    setOptumLoginId('');
    fetchScouts();
  };

  const pollScoutStatus = async (id) => {
    try {
      const response = await fetch(`${BASE_URL}/scout/${id}`, {
        headers: {
          'Authorization': `Bearer ${apiKey.key}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        if (data.urls) {
          setUrls(data.urls);
          if (!data.urls.length) {
            setActiveUrlTab(0);
          }
        }
        if (selectedScout && selectedScout.id === id) {
          setSelectedScout(data);
        }
        setScouts(prevScouts => 
          prevScouts.map(scout => 
            scout.id === id ? data : scout
          )
        );
        if (data.status !== 'IN_PROGRESS') {
          clearInterval(pollingIntervals[id]);
          setPollingIntervals(prev => {
            const newIntervals = { ...prev };
            delete newIntervals[id];
            return newIntervals;
          });
        }
      }
    } catch (error) {
      console.error('Error polling Scout status:', error);
      clearInterval(pollingIntervals[id]);
      setPollingIntervals(prev => {
        const newIntervals = { ...prev };
        delete newIntervals[id];
        return newIntervals;
      });
    }
  };

  const closeViewModal = () => {
    if (selectedScout && pollingIntervals[selectedScout.id]) {
      clearInterval(pollingIntervals[selectedScout.id]);
      setPollingIntervals(prev => {
        const newIntervals = { ...prev };
        delete newIntervals[selectedScout.id];
        return newIntervals;
      });
    }
    // Clean up player when closing modal
    if (player) {
      const replayer = player.getReplayer();
      if (replayer) {
        replayer.pause();
        replayer.destroy();
      }
      setPlayer(null);
    }
    // Clean up both possible recording player elements
    const scoutPlayer = document.getElementById("recording-player-scout");
    const scriptPlayer = document.getElementById("recording-player-script");
    if (scoutPlayer) scoutPlayer.innerHTML = "";
    if (scriptPlayer) scriptPlayer.innerHTML = "";
    
    setIsViewModalOpen(false);
    setSelectedScout(null);
    setSelectedScript(null);
    setActiveTab('details');
    setActiveUrlTab(0);
    setUrls([]);
    setRecording(null);
  };

  useEffect(() => {
    return () => {
      Object.values(pollingIntervals).forEach(interval => clearInterval(interval));
    };
  }, [pollingIntervals]);

  const handleCancelScout = async () => {
    try {
      const response = await fetch(`${BASE_URL}/scout/${selectedScout.id}/cancel`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${apiKey.key}`
        }
      });

      if (response.ok) {
        setIsViewModalOpen(false);
        fetchScouts();
      }
    } catch (error) {
      console.error('Error canceling Scout session:', error);
    }
  };

  const truncateText = (text) => {
    if (!text) return '-';
    return text.length > 50 ? text.substring(0, 47) + '...' : text;
  };

  const handleCreateScript = async () => {
    try {
      const response = await fetch(`${BASE_URL}/scout/execute-script`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${apiKey.key}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          script: newScript,
          requirements_txt: requirementsTxt,
          cookie_name: selectedCookie || undefined,
          advanced_browser_settings: advancedBrowserSettings
        })
      });

      if (response.ok) {
        setIsCreateModalOpen(false);
        setNewScript('');
        setRequirementsTxt('');
        setSelectedCookie('');
        setAdvancedBrowserSettings(false);
        fetchCustomScripts();
      }
    } catch (error) {
      console.error('Error creating custom script:', error);
    }
  };

  const handleViewScript = (script) => {
    setSelectedScript(script);
    setActiveTab('details');
    setIsViewModalOpen(true);
    if (script.status === 'COMPLETED' || script.status === 'ERROR') {
      fetchRecording(script.id, 'custom');
    }
  };

  const downloadTemplateFiles = async () => {
    // Create template script content
    const templateScript = `"""
Scout Playwright Template Script

This template provides a starting point for creating Playwright automation scripts
that work both locally and on the Scout cloud platform.

Instructions:
1. Modify the run_script() function with your automation logic
2. Add any required packages to requirements.txt
3. Test locally using the code at the bottom of this file
4. Remove or comment out the local testing code before uploading to Scout
5. Upload only the run_script() function and any helper functions to Scout
"""

import os
from datetime import datetime

async def run_script(browser_context):
    """
    Main entry point for your Playwright automation script.
    
    This function is called by both local testing and the Scout cloud platform.
    It receives a browser context that's already set up and ready to use.
    
    Args:
        browser_context: Browser context (provided by Scout or your local setup)
        
    Returns:
        Optional result object that will be displayed in Scout's output
        Can be a dictionary, string, or any JSON-serializable object
    """
    
    # Create a new page from the provided context
    # Note: Don't create your own browser or context - use the provided one
    page = await browser_context.new_page()
    
    try:
        # =================================================================
        # YOUR AUTOMATION LOGIC GOES HERE
        # =================================================================
        
        # Example: Navigate to a website
        print("Navigating to example.com...")
        await page.goto('https://example.com')
        
        # Example: Get page information
        title = await page.title()
        url = page.url
        print(f"Page title: {title}")
        print(f"Current URL: {url}")
        
        # Example: Take a screenshot
        # The 'session_dir' variable is available globally and points to 
        # a directory where you can save files (screenshots, downloads, etc.)
        timestamp = datetime.now().strftime("%Y%m%d_%H%M%S")
        screenshot_path = f"{session_dir}/screenshot_{timestamp}.png"
        await page.screenshot(path=screenshot_path)
        print(f"Screenshot saved to: {screenshot_path}")
        
        # Example: Interact with page elements
        # Uncomment and modify these examples as needed:
        
        # # Fill out a form
        # await page.fill('input[name="search"]', 'your search term')
        # await page.press('input[name="search"]', 'Enter')
        
        # # Click a button
        # await page.click('button[type="submit"]')
        
        # # Wait for elements to appear
        # await page.wait_for_selector('.results')
        
        # # Extract text from elements
        # results = await page.query_selector_all('.result-item')
        # result_texts = []
        # for result in results:
        #     text = await result.inner_text()
        #     result_texts.append(text)
        
        # # Handle downloads (if your script downloads files)
        # with page.expect_download() as download_info:
        #     await page.click('a[download]')  # Click download link
        # download = await download_info.value
        # download_path = f"{session_dir}/{download.suggested_filename}"
        # await download.save_as(download_path)
        # print(f"File downloaded to: {download_path}")
        
        # =================================================================
        # RETURN YOUR RESULTS
        # =================================================================
        
        # Return a summary of what your script accomplished
        # This will be displayed in Scout's interface
        return {
            "status": "success",
            "title": title,
            "url": url,
            "screenshot": screenshot_path,
            "message": "Script completed successfully!"
        }
        
    except Exception as e:
        # Handle errors gracefully
        print(f"Error during script execution: {str(e)}")
        
        # Take a screenshot of the error state for debugging
        try:
            error_screenshot = f"{session_dir}/error_screenshot_{datetime.now().strftime('%Y%m%d_%H%M%S')}.png"
            await page.screenshot(path=error_screenshot)
            print(f"Error screenshot saved to: {error_screenshot}")
        except:
            pass
        
        # Return error information
        return {
            "status": "error",
            "message": str(e),
            "error_type": type(e).__name__
        }
        
    finally:
        # IMPORTANT: Always close pages you create
        # Don't close the browser context - that's managed by Scout
        await page.close()
        print("Page closed, script finished")


# =================================================================
# LOCAL TESTING CODE
# =================================================================
# Use this section to test your script locally before uploading to Scout
# REMOVE OR COMMENT OUT this section before uploading to Scout platform

if __name__ == "__main__":
    import asyncio
    from playwright.async_api import async_playwright
    
    # Set up session_dir for local testing
    # This mimics the global session_dir variable available in Scout
    session_dir = "./downloads"
    os.makedirs(session_dir, exist_ok=True)
    
    async def test_locally():
        """
        Local testing function - runs your script with a local browser
        """
        print("=" * 50)
        print("STARTING LOCAL TEST")
        print("=" * 50)
        
        async with async_playwright() as playwright:
            # Launch browser locally (you can change headless=False to see the browser)
            browser = await playwright.chromium.launch(headless=False)
            
            # Create a browser context (similar to what Scout provides)
            context = await browser.new_context()
            
            try:
                # Run your script with the local context
                print("Running script...")
                result = await run_script(context)
                
                print("=" * 50)
                print("SCRIPT RESULT:")
                print(result)
                print("=" * 50)
                
            except Exception as e:
                print(f"Local test failed: {e}")
                
            finally:
                # Clean up
                await browser.close()
                print("Local test completed")
    
    # Run the local test
    print("To run this script locally, execute: python template_script.py")
    print("Make sure you have playwright installed: pip install playwright")
    print("And browser binaries: playwright install")
    print()
    
    # Uncomment the next line to run the test automatically
    # asyncio.run(test_locally())
`;

    // Create requirements.txt content
    const requirementsTxt = `# Requirements.txt for Scout Playwright Script
# 
# This file lists the Python packages your script needs.
# Scout already has these packages installed, so you don't need to list them:
# - playwright (the main Playwright package)
# - requests (for HTTP requests)
# - asyncio (for async functionality)
# - Standard Python libraries (os, json, datetime, etc.)
#
# Add any additional packages your script needs below.
# Use specific versions when possible for consistency.
#
# Examples of commonly used packages:

# Data processing and analysis
# pandas>=1.4.0
# numpy>=1.21.0

# Web scraping helpers
# beautifulsoup4==4.11.1
# lxml>=4.6.0

# HTTP requests (if you need more than the built-in requests)
# httpx>=0.23.0

# Environment variables
# python-dotenv>=0.19.0

# Date/time utilities
# python-dateutil>=2.8.0

# JSON processing
# jsonschema>=4.0.0

# File processing
# openpyxl>=3.0.0  # For Excel files
# PyPDF2>=2.0.0    # For PDF files

# Add your specific requirements below:
# your-package-name==1.0.0
`;

    try {
      // Create a ZIP file containing both template files
      const zip = new JSZip();
      
      // Add files to the ZIP
      zip.file('template_script.py', templateScript);
      zip.file('requirements.txt', requirementsTxt);
      
      // Generate the ZIP file
      const zipBlob = await zip.generateAsync({ type: 'blob' });
      
      // Create download link for the ZIP file
      const zipUrl = URL.createObjectURL(zipBlob);
      const zipLink = document.createElement('a');
      zipLink.href = zipUrl;
      zipLink.download = 'scout_template.zip';
      document.body.appendChild(zipLink);
      zipLink.click();
      document.body.removeChild(zipLink);
      URL.revokeObjectURL(zipUrl);
      
      console.log('Template ZIP file downloaded successfully');
      
    } catch (error) {
      console.error('Error downloading template files:', error);
      alert('Error downloading template files. Please try again.');
    }
  };

  const fetch835Scrapers = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const url = `${BASE_URL}/scout/list_835_scrapers?limit=${pageSize}&offset=${offset}`;
      const response = await fetch(url, {
        headers: {
          'Authorization': `Bearer ${apiKey.key}`
        }
      });
      if (response.ok) {
        const data = await response.json();
        setScrapers835(data);
        setTotalCount(data.length);
      } else {
        const errorData = await response.json();
        console.error('[835 Scrapers] Error response:', errorData);
        const errorMessage = typeof errorData.detail === 'string' ? errorData.detail : 'Failed to fetch 835 scrapers';
        setError(errorMessage);
        console.error('[835 Scrapers] Set error state:', errorMessage);
      }
    } catch (error) {
      console.error('[835 Scrapers] Fetch error:', error);
      const errorMessage = 'Failed to fetch 835 scrapers. Please check your connection.';
      setError(errorMessage);
      console.error('[835 Scrapers] Set error state (catch):', errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  const fetch835Backfills = async (silent = false) => {
    if (!silent) setIsLoading(true);
    if (!silent) setError(null);
    try {
      const page = Math.floor(offset / pageSize) + 1;
      const urls = [
        `${BASE_URL}/jobs/?job_type=ecw_835_backfill&page=${page}&size=${pageSize}`,
        `${BASE_URL}/jobs/?job_type=ecw_posted_835_backfill&page=${page}&size=${pageSize}`,
        `${BASE_URL}/jobs/?job_type=echo_835_backfill&page=${page}&size=${pageSize}`,
        `${BASE_URL}/jobs/?job_type=echo_date_range_835_backfill&page=${page}&size=${pageSize}`,
        `${BASE_URL}/jobs/?job_type=echo_date_range_eob_backfill&page=${page}&size=${pageSize}`,
        `${BASE_URL}/jobs/?job_type=zelis_835_backfill&page=${page}&size=${pageSize}`,
        `${BASE_URL}/jobs/?job_type=instamed_835_backfill&page=${page}&size=${pageSize}`,
        `${BASE_URL}/jobs/?job_type=payspan_835_backfill&page=${page}&size=${pageSize}`,
        `${BASE_URL}/jobs/?job_type=ashlink_835_backfill&page=${page}&size=${pageSize}`,
        `${BASE_URL}/jobs/?job_type=athena_835_backfill&page=${page}&size=${pageSize}`,
        `${BASE_URL}/jobs/?job_type=utah_medicaid_835_backfill&page=${page}&size=${pageSize}`,
        `${BASE_URL}/jobs/?job_type=${UHC_BACKFILL_JOB_TYPE}&page=${page}&size=${pageSize}`,
        `${BASE_URL}/jobs/?job_type=${OPTUM_BACKFILL_JOB_TYPE}&page=${page}&size=${pageSize}`,
      ];

      const [ecwResp, ecwPostedResp, echoResp, echoDateRangeResp, echoDateRangeEobResp, zelisResp, instamedResp, payspanResp, ashlinkResp, athenaResp, utahResp, uhcResp, optumResp] = await Promise.all(
        urls.map((u) => fetch(u, { headers: { 'Authorization': `Bearer ${apiKey.key}` } }))
      );

      if (ecwResp.ok && ecwPostedResp.ok && echoResp.ok && echoDateRangeResp.ok && echoDateRangeEobResp.ok && zelisResp.ok && instamedResp.ok && payspanResp.ok && ashlinkResp.ok && athenaResp.ok && utahResp.ok && uhcResp.ok && optumResp.ok) {
        const ecwData = await ecwResp.json();
        const ecwPostedData = await ecwPostedResp.json();
        const echoData = await echoResp.json();
        const echoDateRangeData = await echoDateRangeResp.json();
        const echoDateRangeEobData = await echoDateRangeEobResp.json();
        const zelisData = await zelisResp.json();
        const instamedData = await instamedResp.json();
        const payspanData = await payspanResp.json();
        const ashlinkData = await ashlinkResp.json();
        const athenaData = await athenaResp.json();
        const utahData = await utahResp.json();
        const uhcData = await uhcResp.json();
        const optumData = await optumResp.json();
        const jobs = [
          ...(ecwData.jobs || []),
          ...(ecwPostedData.jobs || []),
          ...(echoData.jobs || []),
          ...(echoDateRangeData.jobs || []),
          ...(echoDateRangeEobData.jobs || []),
          ...(zelisData.jobs || []),
          ...(instamedData.jobs || []),
          ...(payspanData.jobs || []),
          ...(ashlinkData.jobs || []),
          ...(athenaData.jobs || []),
          ...(utahData.jobs || []),
          ...(uhcData.jobs || []),
          ...(optumData.jobs || []),
        ];
        // Sort by ID in descending order (newest first)
        jobs.sort((a, b) => b.id - a.id);
        const total = (ecwData.total || 0) + (ecwPostedData.total || 0) + (echoData.total || 0) + (echoDateRangeData.total || 0) + (echoDateRangeEobData.total || 0) + (zelisData.total || 0) + (instamedData.total || 0) + (payspanData.total || 0) + (ashlinkData.total || 0) + (athenaData.total || 0) + (utahData.total || 0) + (uhcData.total || 0) + (optumData.total || 0);
        setBackfills835(jobs);
        setTotalCount(total);
      } else {
        const ecwErr = ecwResp.ok ? null : await ecwResp.json();
        const echoErr = echoResp.ok ? null : await echoResp.json();
        const zelisErr = zelisResp.ok ? null : await zelisResp.json();
        const instamedErr = instamedResp.ok ? null : await instamedResp.json();
        const payspanErr = payspanResp.ok ? null : await payspanResp.json();
        const ashlinkErr = ashlinkResp.ok ? null : await ashlinkResp.json();
        console.error('[835 Backfills] Error response:', { ecwErr, echoErr, zelisErr, instamedErr, payspanErr, ashlinkErr });
        const errorMessage = 'Failed to fetch 835 backfills';
        setError(errorMessage);
      }
    } catch (error) {
      console.error('[835 Backfills] Fetch error:', error);
      const errorMessage = 'Failed to fetch 835 backfills. Please check your connection.';
      setError(errorMessage);
      console.error('[835 Backfills] Set error state (catch):', errorMessage);
    } finally {
      if (!silent) setIsLoading(false);
    }
  };

  const handleCreate835Scraper = async () => {
    try {
      const url = `${BASE_URL}/scout/create_835_scraper`;
      const requestBody = {
        payer: selectedPayer,
        site_id: siteId,
        username: username || undefined,
        password: password || undefined,
        corporate_id: corporateId || undefined
      };
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${apiKey.key}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody)
      });
      if (response.ok) {
        fetch835Scrapers();
      } else {
        const errorData = await response.json();
        console.error('[835 Scrapers] Error response:', errorData);
        const errorMessage = typeof errorData.detail === 'string' ? errorData.detail : 'Failed to create 835 scraper';
        setError(errorMessage);
        console.error('[835 Scrapers] Set error state:', errorMessage);
      }
    } catch (error) {
      console.error('[835 Scrapers] Create error:', error);
      const errorMessage = 'Failed to create 835 scraper. Please check your connection.';
      setError(errorMessage);
      console.error('[835 Scrapers] Set error state (catch):', errorMessage);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-8 py-6">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-3xl font-bold text-gray-900">Scout Dashboard</h1>
          <div className="flex gap-4">
            <Button onClick={() => {
              setIsCreateModalOpen(true);
              const newActiveTab = activeTableTab === 'scouts' 
                ? 'scout' 
                : activeTableTab === 'scripts' 
                ? 'script' 
                : activeTableTab === '835scrapers' 
                ? '835scraper' 
                : '835backfill';
              setActiveCreateTab(newActiveTab);
            }}>
              + New {activeTableTab === 'scouts' ? 'Scout Session' : activeTableTab === 'scripts' ? 'Custom Script' : activeTableTab === '835scrapers' ? '835 Scraper' : '835 Backfill'}
            </Button>
            <Link to="/view-recordings"><Button>View Scout Recordings</Button></Link>
            <Link to="/cookies"><Button>Manage Cookies</Button></Link>
          </div>
        </div>

        <Card>
          <div className="overflow-x-auto">
            <div className="border-b border-gray-200">
              <div className="flex">
                <button
                  onClick={() => setActiveTableTab('scouts')}
                  className={`px-4 py-2 ${
                    activeTableTab === 'scouts'
                      ? 'border-b-2 border-blue-500 text-blue-600'
                      : 'text-gray-500 hover:text-gray-700'
                  }`}
                >
                  Scout Runs
                </button>
                <button
                  onClick={() => setActiveTableTab('scripts')}
                  className={`px-4 py-2 ${
                    activeTableTab === 'scripts'
                      ? 'border-b-2 border-blue-500 text-blue-600'
                      : 'text-gray-500 hover:text-gray-700'
                  }`}
                >
                  Custom Scripts
                </button>
                <button
                  onClick={() => {
                    setActiveTableTab('835scrapers');
                  }}
                  className={`px-4 py-2 ${
                    activeTableTab === '835scrapers'
                      ? 'border-b-2 border-blue-500 text-blue-600'
                      : 'text-gray-500 hover:text-gray-700'
                  }`}
                >
                  835 Scrapers
                </button>
                <button
                  onClick={() => {
                    setActiveTableTab('835backfills');
                  }}
                  className={`px-4 py-2 ${
                    activeTableTab === '835backfills'
                      ? 'border-b-2 border-blue-500 text-blue-600'
                      : 'text-gray-500 hover:text-gray-700'
                  }`}
                >
                  835 Backfills
                </button>
              </div>
            </div>

                          {isLoading ? (
                <div className="p-8 text-center text-gray-600">
                Loading {activeTableTab === 'scouts' ? 'sessions' : activeTableTab === 'scripts' ? 'scripts' : activeTableTab === '835scrapers' ? 'scrapers' : 'backfills'}...
              </div>
            ) : error ? (
              <div className="p-8 text-center text-red-600">
                {error}
              </div>
            ) : activeTableTab === 'scouts' ? (
              scouts.length === 0 ? (
                <div className="p-8 text-center text-gray-600">
                  No Scout sessions found. Create one using the + New Scout Session button.
                </div>
              ) : (
                <>
                  <table className="min-w-full">
                    <thead>
                      <tr>
                        <th className="py-3 px-4 text-left">ID</th>
                        <th className="py-3 px-4 text-left">User Prompt</th>
                        <th className="py-3 px-4 text-left">Scout Response</th>
                        <th className="py-3 px-4 text-left">Comments</th>
                        <th className="py-3 px-4 text-left">Status</th>
                        <th className="py-3 px-4 text-left">Created At</th>
                      </tr>
                    </thead>
                    <tbody>
                      {scouts.map((scout) => (
                        <tr key={scout.id} className="border-t border-gray-200">
                          <td
                            className="py-3 px-4 cursor-pointer hover:text-blue-600"
                          >
                            <div className="flex items-center space-x-2">
                              <Link to={`/replay/${scout.id}`} className="text-blue-600 hover:text-blue-800">
                                {scout.id}
                              </Link>
                              <button
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleViewScout(scout);
                                }}
                                className="p-1 hover:bg-gray-100 rounded-full"
                                title="View Details"
                              >
                                <svg
                                  className="w-5 h-5 text-gray-500 hover:text-gray-700"
                                  fill="none"
                                  stroke="currentColor"
                                  viewBox="0 0 24 24"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                                  />
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                                  />
                                </svg>
                              </button>
                            </div>
                          </td>
                          <td className="py-3 px-4">{truncateText(scout.user_prompt)}</td>
                          <td className="py-3 px-4">{truncateText(scout.operator_response)}</td>
                          <td className="py-3 px-4">{truncateText(scout.comments)}</td>
                          <td className="py-3 px-4">
                            <span className={`inline-block px-2 py-1 text-sm font-medium rounded-md ${
                              scout.status === 'COMPLETED' ? 'bg-green-100 text-green-700' :
                              scout.status === 'IN_PROGRESS' ? 'bg-blue-100 text-blue-700' :
                              scout.status === 'ERROR' ? 'bg-red-100 text-red-700' :
                              'bg-gray-100 text-gray-700'
                            }`}>
                              {scout.status}
                            </span>
                          </td>
                          <td className="py-3 px-4">{scout.created_at ? new Date(scout.created_at).toLocaleString() : '-'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </>
              )
            ) : activeTableTab === 'scripts' ? (
              customScripts.length === 0 ? (
                <div className="p-8 text-center text-gray-600">
                  No custom scripts found. Create one using the + New Script button.
                </div>
              ) : (
                <>
                  <table className="min-w-full">
                    <thead>
                      <tr>
                        <th className="py-3 px-4 text-left">ID</th>
                        <th className="py-3 px-4 text-left">Script</th>
                        <th className="py-3 px-4 text-left">Result</th>
                        <th className="py-3 px-4 text-left">Status</th>
                        <th className="py-3 px-4 text-left">Created At</th>
                      </tr>
                    </thead>
                    <tbody>
                      {customScripts.map((script) => (
                        <tr key={script.id} className="border-t border-gray-200">
                          <td className="py-3 px-4">
                            <button
                              onClick={() => handleViewScript(script)}
                              className="text-blue-600 hover:text-blue-800"
                            >
                              {script.id}
                            </button>
                          </td>
                          <td className="py-3 px-4">{truncateText(script.script)}</td>
                          <td className="py-3 px-4">{truncateText(script.result)}</td>
                          <td className="py-3 px-4">
                            <span className={`inline-block px-2 py-1 text-sm font-medium rounded-md ${
                              script.status === 'COMPLETED' ? 'bg-green-100 text-green-700' :
                              script.status === 'IN_PROGRESS' ? 'bg-blue-100 text-blue-700' :
                              script.status === 'ERROR' ? 'bg-red-100 text-red-700' :
                              'bg-gray-100 text-gray-700'
                            }`}>
                              {script.status}
                            </span>
                          </td>
                          <td className="py-3 px-4">{script.created_at ? new Date(script.created_at).toLocaleString() : '-'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </>
              )
            ) : activeTableTab === '835backfills' ? (
              backfills835.length === 0 ? (
                <div className="p-8 text-center text-gray-600">
                  No 835 backfills found. Create one using the + New Backfill button.
                </div>
              ) : (
                <>
                  <table className="min-w-full">
                    <thead>
                      <tr>
                        <th className="py-3 px-4 text-left">ID</th>
                        <th className="py-3 px-4 text-left">Job Name</th>
                        <th className="py-3 px-4 text-left">Status</th>
                        <th className="py-3 px-4 text-left">Created At</th>
                      </tr>
                    </thead>
                    <tbody>
                      {backfills835.map((job) => (
                        <tr key={job.id} className="border-t border-gray-200">
                          <td className="py-3 px-4">{job.id}</td>
                          <td className="py-3 px-4">{job.job_name || '-'}</td>
                          <td className="py-3 px-4">
                            <span className={`inline-block px-2 py-1 text-sm font-medium rounded-md ${
                              job.status === 'COMPLETED' ? 'bg-green-100 text-green-700' :
                              job.status === 'RUNNING' || job.status === 'QUEUED' ? 'bg-blue-100 text-blue-700' :
                              job.status === 'FAILED' ? 'bg-red-100 text-red-700' :
                              'bg-gray-100 text-gray-700'
                            }`}>
                              {job.status}
                            </span>
                            {job.job_type === 'utah_medicaid_835_backfill' && <UtahBackfillResult job={job} />}
                            {job.job_type === UHC_BACKFILL_JOB_TYPE && <UhcBackfillResult job={job} />}
                            {job.job_type === OPTUM_BACKFILL_JOB_TYPE && <OptumBackfillResult job={job} />}
                          </td>
                          <td className="py-3 px-4">{job.created_at ? new Date(job.created_at).toLocaleString() : '-'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </>
              )
            ) : (
              scrapers835.length === 0 ? (
                <div className="p-8 text-center text-gray-600">
                  No 835 scrapers found. Create one using the + New Scraper button.
                </div>
              ) : (
                <>
                  <table className="min-w-full">
                    <thead>
                      <tr>
                        <th className="py-3 px-4 text-left">ID</th>
                        <th className="py-3 px-4 text-left">Scraper</th>
                        <th className="py-3 px-4 text-left">Status</th>
                        <th className="py-3 px-4 text-left">Created At</th>
                      </tr>
                    </thead>
                    <tbody>
                      {scrapers835.map((scraper) => (
                        <tr key={scraper.id} className="border-t border-gray-200">
                          <td className="py-3 px-4">{scraper.id}</td>
                          <td className="py-3 px-4">{scraper.name}</td>
                          <td className="py-3 px-4">
                            <span className={`inline-block px-2 py-1 text-sm font-medium rounded-md ${
                              scraper.status === 'COMPLETED' ? 'bg-green-100 text-green-700' :
                              scraper.status === 'IN_PROGRESS' ? 'bg-blue-100 text-blue-700' :
                              scraper.status === 'ERROR' ? 'bg-red-100 text-red-700' :
                              'bg-gray-100 text-gray-700'
                            }`}>
                              {scraper.status}
                            </span>
                          </td>
                          <td className="py-3 px-4">{scraper.created_at ? new Date(scraper.created_at).toLocaleString() : '-'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </>
              )
            )}
            <div className="flex justify-between items-center p-4 border-t border-gray-200">
              <div>
                Showing {activeTableTab === 'scouts' ? scouts.length : activeTableTab === 'scripts' ? customScripts.length : activeTableTab === '835scrapers' ? scrapers835.length : backfills835.length} of {totalCount} {activeTableTab === 'scouts' ? 'Scout sessions' : activeTableTab === 'scripts' ? 'Custom scripts' : activeTableTab === '835scrapers' ? 'Scrapers' : 'Backfills'}
              </div>
              <div className="flex space-x-2">
                <Button
                  onClick={() => setOffset(Math.max(0, offset - pageSize))}
                  disabled={offset === 0}
                  className={offset === 0 ? 'opacity-50 cursor-not-allowed' : ''}
                >
                  Previous
                </Button>
                <Button
                  onClick={() => setOffset(offset + pageSize)}
                  disabled={(activeTableTab === 'scouts' ? scouts.length : activeTableTab === 'scripts' ? customScripts.length : activeTableTab === '835scrapers' ? scrapers835.length : backfills835.length) < pageSize}
                  className={(activeTableTab === 'scouts' ? scouts.length : activeTableTab === 'scripts' ? customScripts.length : activeTableTab === '835scrapers' ? scrapers835.length : backfills835.length) < pageSize ? 'opacity-50 cursor-not-allowed' : ''}
                >
                  Next
                </Button>
              </div>
            </div>
          </div>
        </Card>
      </div>

      {/* Create Modal */}
      {isCreateModalOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center"
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              closeCreateScoutModal();
            }
          }}
        >
          <Card className="w-full max-w-lg max-h-[80vh] flex flex-col overflow-hidden">
            <div className="p-6 flex-shrink-0">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Create New Session</h2>
              <div className="flex border-b border-gray-200 mb-4">
                <button
                  onClick={() => setActiveCreateTab('scout')}
                  className={`px-4 py-2 ${
                    activeCreateTab === 'scout'
                      ? 'border-b-2 border-blue-500 text-blue-600'
                      : 'text-gray-500 hover:text-gray-700'
                  }`}
                >
                  Scout Session
                </button>
                <button
                  onClick={() => setActiveCreateTab('script')}
                  className={`px-4 py-2 ${
                    activeCreateTab === 'script'
                      ? 'border-b-2 border-blue-500 text-blue-600'
                      : 'text-gray-500 hover:text-gray-700'
                  }`}
                >
                  Custom Script
                </button>
                <button
                  onClick={() => {
                    setActiveCreateTab('835scraper');
                  }}
                  className={`px-4 py-2 ${
                    activeCreateTab === '835scraper'
                      ? 'border-b-2 border-blue-500 text-blue-600'
                      : 'text-gray-500 hover:text-gray-700'
                  }`}
                >
                  835 Scraper
                </button>
                <button
                  onClick={() => {
                    setActiveCreateTab('835backfill');
                  }}
                  className={`px-4 py-2 ${
                    activeCreateTab === '835backfill'
                      ? 'border-b-2 border-blue-500 text-blue-600'
                      : 'text-gray-500 hover:text-gray-700'
                  }`}
                >
                  835 Backfill
                </button>
              </div>
            </div>
            <div className="p-6 pt-0 overflow-y-auto flex-grow">
              {activeCreateTab === 'scout' ? (
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Prompt
                    </label>
                    <textarea
                      value={newPrompt}
                      onChange={(e) => setNewPrompt(e.target.value)}
                      className="w-full h-32 p-2 border border-gray-300 rounded-md resize-none focus:outline-none focus:ring-2 focus:ring-blue-500"
                      placeholder="Enter your prompt here..."
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Temperature: {temperature}
                    </label>
                    <input
                      type="range"
                      min="0"
                      max="2"
                      step="0.1"
                      value={temperature}
                      onChange={(e) => setTemperature(parseFloat(e.target.value))}
                      className="w-full"
                    />
                    <div className="flex justify-between text-xs text-gray-500">
                      <span>More Focused</span>
                      <span>More Creative</span>
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Cookies (Optional)
                    </label>
                    <div className="relative">
                      <div className="relative">
                        <input
                          type="text"
                          placeholder="Search and select cookies..."
                          value={selectedCookie || cookieSearchQuery}
                          onChange={(e) => {
                            setCookieSearchQuery(e.target.value);
                            setSelectedCookie('');
                            setDepositCookies(false);
                          }}
                          onFocus={() => setIsDropdownOpen(true)}
                          className="w-full px-4 py-2 border border-gray-300 rounded-md pr-20"
                        />
                        <div className="absolute inset-y-0 right-0 flex items-center">
                          {selectedCookie && (
                            <button
                              type="button"
                              onClick={() => {
                                setSelectedCookie('');
                                setCookieSearchQuery('');
                                setDepositCookies(false);
                              }}
                              className="p-2 hover:text-red-600"
                              title="Clear selection"
                            >
                              <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd"/>
                              </svg>
                            </button>
                          )}
                          <button
                            type="button"
                            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                            className="p-2"
                          >
                            <svg className="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="none" stroke="currentColor">
                              <path d="M7 7l3-3 3 3m0 6l-3 3-3-3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                          </button>
                        </div>
                      </div>
                      {isDropdownOpen && (
                        <div className="absolute z-10 w-full mt-1 bg-white shadow-lg max-h-60 rounded-md py-1 text-base overflow-auto focus:outline-none sm:text-sm">
                          {availableCookies
                            .filter(cookie => 
                              cookie.name.toLowerCase().includes((selectedCookie || cookieSearchQuery).toLowerCase())
                            )
                            .map(cookie => (
                              <div
                                key={cookie.id}
                                className={`cursor-pointer select-none relative py-2 pl-3 pr-9 hover:bg-blue-50 ${
                                  selectedCookie === cookie.name ? 'bg-blue-50 text-blue-900' : 'text-gray-900'
                                }`}
                                onClick={() => {
                                  setSelectedCookie(cookie.name);
                                  setCookieSearchQuery('');
                                  setIsDropdownOpen(false);
                                }}
                              >
                                <span className="block truncate">{cookie.name}</span>
                                {selectedCookie === cookie.name && (
                                  <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-blue-600">
                                    <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                                    </svg>
                                  </span>
                                )}
                              </div>
                            ))}
                          {availableCookies.filter(cookie => 
                            cookie.name.toLowerCase().includes((selectedCookie || cookieSearchQuery).toLowerCase())
                          ).length === 0 && (
                            <div className="cursor-default select-none relative py-2 pl-3 pr-9 text-gray-500">
                              No cookies found
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                    <div className="mt-2">
                      <label className="flex items-center text-sm text-gray-600">
                        <input
                          type="checkbox"
                          checked={depositCookies}
                          onChange={(e) => setDepositCookies(e.target.checked)}
                          disabled={!selectedCookie}
                          className="mr-2 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded disabled:opacity-50"
                        />
                        Deposit cookies after session
                      </label>
                    </div>
                  </div>

                  <div className="flex items-center">
                    <input
                      type="checkbox"
                      id="advancedBrowserSettings"
                      checked={advancedBrowserSettings}
                      onChange={(e) => setAdvancedBrowserSettings(e.target.checked)}
                      className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                    />
                    <label htmlFor="advancedBrowserSettings" className="ml-2 block text-sm text-gray-700">
                      Use Advanced Browser Settings
                    </label>
                  </div>

                  <div className="flex justify-end mt-4">
                    <Button 
                      onClick={handleCreateScout}
                      className="bg-blue-600 text-white hover:bg-blue-700 mr-2"
                    >
                      Create Scout Session
                    </Button>
                    <Button 
                      onClick={closeCreateScoutModal}
                      className="bg-gray-400 text-white hover:bg-gray-500"
                    >
                      Cancel
                    </Button>
                  </div>
                </div>
              ) : activeCreateTab === 'script' ? (
                <div className="space-y-4">
                  <div className="bg-gray-50 p-6 rounded-lg border border-gray-200">
                    <h2 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                      <svg className="w-6 h-6 mr-2 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
                      </svg>
                      Create Custom Playwright Script
                    </h2>
                    <p className="text-gray-600 mb-4">
                      Create and run Playwright automation scripts in the cloud using Browserbase. Your script will interact with websites, take screenshots, download files, and more - all executed on our secure cloud infrastructure.
                    </p>
                    
                    {/* Download Template Button */}
                    <div className="mb-4 flex justify-center">
                      <button
                        onClick={downloadTemplateFiles}
                        className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors flex items-center font-medium"
                      >
                        <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 10v6m0 0l-4-4m4 4l4-4m-4-4V3m0 0L8 7m4-4l4 4" />
                        </svg>
                        Download Template Files
                      </button>
                    </div>
                    
                    <div className="flex items-center space-x-2 mb-4 bg-blue-50 p-3 rounded-lg border border-blue-200">
                      <svg className="w-5 h-5 text-blue-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      <p className="text-sm text-blue-600">
                        Your script will run on a Browserbase instance with all browser infrastructure pre-configured. Just focus on your automation logic!
                      </p>
                      <button
                        onClick={() => setIsExampleModalOpen(true)}
                        className="ml-auto px-3 py-1 bg-indigo-600 text-white text-sm rounded-md hover:bg-indigo-700 transition-colors flex-shrink-0"
                      >
                        View Concept & Examples
                      </button>
                    </div>
                    
                    {/* Script Writing Guide */}
                    <div className="bg-blue-50 p-4 rounded-lg border border-blue-200 mb-4">
                      <h3 className="font-medium text-blue-800 mb-2">How to Write Your Script</h3>
                      <div className="text-sm text-blue-700 space-y-3">
                        <div>
                          <p className="font-medium">Write your script as a <code className="bg-blue-100 px-1 rounded">run_script(browser_context)</code> function:</p>
                          <ul className="list-disc pl-5 mt-1 space-y-1">
                            <li>This function is the <span className="font-semibold">only required element</span> in your script</li>
                            <li>It receives a browser context as its parameter</li>
                            <li>Create pages from this context: <code className="bg-blue-100 px-1 rounded">page = await browser_context.new_page()</code></li>
                            <li>Use <code className="bg-blue-100 px-1 rounded">session_dir</code> global variable to save files</li>
                            <li>Return results that will appear in the output</li>
                          </ul>
                        </div>
                        
                        <div>
                          <p className="font-medium">Best practices:</p>
                          <ul className="list-disc pl-5 mt-1 space-y-1">
                            <li>Use <code className="bg-blue-100 px-1 rounded">async/await</code> patterns - your script runs in an async environment</li>
                            <li>Always close pages you create when finished</li>
                            <li>Use try/finally blocks for proper cleanup</li>
                            <li>Use <code className="bg-blue-100 px-1 rounded">print()</code> statements for debugging (output appears in the results)</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    
                    {/* Common Errors Section */}
                    <div className="bg-orange-50 p-4 rounded-lg border border-orange-200 mb-4">
                      <button 
                        onClick={() => {
                          const errorsSection = document.getElementById('common-errors-content');
                          if (errorsSection) {
                            errorsSection.classList.toggle('hidden');
                          }
                        }}
                        className="w-full flex justify-between items-center text-left font-medium text-orange-800"
                      >
                        <span>Common Errors & Troubleshooting</span>
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                        </svg>
                      </button>
                      
                      <div id="common-errors-content" className="hidden mt-3 text-sm text-orange-700 space-y-3">
                        <div>
                          <p className="font-medium">Module not found errors:</p>
                          <ul className="list-disc pl-5 mt-1 space-y-1">
                            <li>Make sure to include required packages in requirements.txt</li>
                            <li>Avoid importing modules that require system libraries (e.g., some ML libraries)</li>
                            <li>Use pure Python packages when possible</li>
                          </ul>
                        </div>
                        
                        <div>
                          <p className="font-medium">Browser/context errors:</p>
                          <ul className="list-disc pl-5 mt-1 space-y-1">
                            <li>Don't create your own browser or context - use the provided <code className="bg-orange-100 px-1 rounded">browser_context</code> parameter</li>
                            <li>Don't close the browser - only close pages you create</li>
                            <li>Make sure to await all async operations</li>
                            <li>Watch for timeouts on selectors - adjust wait times if needed</li>
                          </ul>
                        </div>
                        
                        <div>
                          <p className="font-medium">File access errors:</p>
                          <ul className="list-disc pl-5 mt-1 space-y-1">
                            <li>Always save files to <code className="bg-orange-100 px-1 rounded">session_dir</code></li>
                            <li>Avoid accessing files outside of <code className="bg-orange-100 px-1 rounded">session_dir</code></li>
                            <li>For downloads, use <code className="bg-orange-100 px-1 rounded">page.expect_download()</code> and wait for it to complete</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    
                    <div className="mb-3">
                      <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center">
                        <span>Playwright Script</span>
                        <span className="ml-1 text-red-500">*</span>
                        <span className="ml-2 text-xs text-gray-500">(Required)</span>
                      </label>
                      
                      {/* Simplified portable code explanation for main form */}
                      <div className="bg-indigo-50 p-3 rounded-lg border border-indigo-200 mb-4">
                        <div className="flex items-center space-x-2">
                          <svg className="w-5 h-5 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                          </svg>
                          <h3 className="font-medium text-indigo-800">Write Once, Run Anywhere</h3>
                        </div>
                        <p className="text-sm text-indigo-700 mt-2">
                          Your <code className="bg-indigo-100 px-1 rounded">run_script()</code> function works both locally and on our platform without changes.
                          <button 
                            onClick={() => setIsExampleModalOpen(true)}
                            className="ml-2 text-indigo-600 hover:text-indigo-800 underline"
                          >
                            See full concept & examples →
                          </button>
                        </p>
                      </div>
                      
                      <div 
                        className="relative border-2 border-dashed border-gray-300 rounded-lg p-1"
                        onDrop={handleScriptDrop}
                        onDragOver={preventDefault}
                        onDragEnter={preventDefault}
                      >
                        <textarea
                          value={newScript}
                          onChange={(e) => setNewScript(e.target.value)}
                          className="w-full h-64 p-2 rounded-md resize-none font-mono text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                          placeholder={`# Define your run_script function to be portable between local and cloud environments

async def run_script(browser_context):
    """
    Main entry point for your Playwright automation script.
    
    Args:
        browser_context: Browser context (provided by our system or your local setup)
    
    Returns:
        Optional result object that will be displayed in the output
    """
    # Create a new page from the provided context
    page = await browser_context.new_page()
    
    try:
        # Navigate to a website
        await page.goto('https://example.com')
        
        # Take a screenshot
        screenshot_path = f"{session_dir}/screenshot.png"
        await page.screenshot(path=screenshot_path)
        print(f"Screenshot saved to: {screenshot_path}")
        
        # Return data (optional)
        return {
            "status": "success",
            "url": page.url,
            "title": await page.title()
        }
        
    finally:
        # Always clean up pages you create
        await page.close()
        

# ------- HOW TO TEST LOCALLY -------
# Uncomment and run this code on your local machine:
#
# import asyncio
# import os
# from playwright.async_api import async_playwright
#
# # Set up session_dir for local testing
# session_dir = "./downloads"
# os.makedirs(session_dir, exist_ok=True)
#
# async def local_test():
#     async with async_playwright() as playwright:
#         browser = await playwright.chromium.launch()
#         context = await browser.new_context()
#         
#         # Run your script with the local browser context
#         result = await run_script(context)
#         print("Result:", result)
#         
#         await browser.close()
#
# # Run it: asyncio.run(local_test())
# ------- END OF LOCAL TESTING CODE -------
`}
                        />
                        
                        <div className="flex justify-between mt-2 p-2">
                          <button
                            type="button"
                            onClick={() => {
                              const fileInput = document.createElement('input');
                              fileInput.type = 'file';
                              fileInput.accept = '.py';
                              fileInput.onchange = (e) => {
                                const file = e.target.files[0];
                                if (file) {
                                  const reader = new FileReader();
                                  reader.onload = (event) => {
                                    setNewScript(event.target.result);
                                  };
                                  reader.readAsText(file);
                                }
                              };
                              fileInput.click();
                            }}
                            className="text-sm text-blue-600 hover:text-blue-800 flex items-center"
                          >
                            <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
                            </svg>
                            Upload Script File
                          </button>
                          <span className="text-xs text-gray-500">
                            Drag & drop .py file here
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                    <div className="mb-3">
                      <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center">
                        <span>requirements.txt</span>
                        <span className="ml-2 text-xs text-gray-500">(Optional)</span>
                      </label>
                      
                      {/* Requirements Guide */}
                      <div className="bg-green-50 p-4 rounded-lg border border-green-200 mb-4">
                        <h3 className="font-medium text-green-800 mb-2">Package Requirements</h3>
                        <div className="text-sm text-green-700 space-y-2">
                          <p>
                            <span className="font-medium">Already installed packages:</span> You don't need to specify these
                          </p>
                          <ul className="list-disc pl-5 space-y-1">
                            <li><code className="bg-green-100 px-1 rounded">playwright</code> - The Playwright package</li>
                            <li><code className="bg-green-100 px-1 rounded">requests</code> - For making HTTP requests</li>
                            <li><code className="bg-green-100 px-1 rounded">asyncio</code> - For async functionality</li>
                            <li>Standard Python libraries (os, json, datetime, etc.)</li>
                          </ul>
                          <p className="font-medium mt-2">Specify any additional packages you need:</p>
                          <ul className="list-disc pl-5 space-y-1">
                            <li>Data processing: <code className="bg-green-100 px-1 rounded">pandas</code>, <code className="bg-green-100 px-1 rounded">numpy</code>, etc.</li>
                            <li>Web scraping: <code className="bg-green-100 px-1 rounded">beautifulsoup4</code>, <code className="bg-green-100 px-1 rounded">lxml</code>, etc.</li>
                            <li>API clients and other specific packages</li>
                          </ul>
                        </div>
                      </div>
                      
                      <div 
                        className="relative border-2 border-dashed border-gray-300 rounded-lg p-1"
                        onDrop={handleRequirementsDrop}
                        onDragOver={preventDefault}
                        onDragEnter={preventDefault}
                      >
                        <textarea
                          value={requirementsTxt}
                          onChange={(e) => setRequirementsTxt(e.target.value)}
                          className="w-full h-32 p-2 rounded-md resize-none font-mono text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                          placeholder={`# One dependency per line, with optional version specifiers
# Example:
pandas>=1.4.0
beautifulsoup4==4.11.1
python-dotenv
# playwright is already installed, you don't need to list it here
`}
                        />
                        
                        <div className="flex justify-between mt-2 p-2">
                          <button
                            type="button"
                            onClick={() => {
                              const fileInput = document.createElement('input');
                              fileInput.type = 'file';
                              fileInput.accept = '.txt';
                              fileInput.onchange = (e) => {
                                const file = e.target.files[0];
                                if (file) {
                                  const reader = new FileReader();
                                  reader.onload = (event) => {
                                    setRequirementsTxt(event.target.result);
                                  };
                                  reader.readAsText(file);
                                }
                              };
                              fileInput.click();
                            }}
                            className="text-sm text-blue-600 hover:text-blue-800 flex items-center"
                          >
                            <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
                            </svg>
                            Upload requirements.txt
                          </button>
                          <span className="text-xs text-gray-500">
                            Drag & drop requirements.txt here
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Cookies (Optional)
                    </label>
                    <div className="relative">
                      <div className="relative">
                        <input
                          type="text"
                          placeholder="Search and select cookies..."
                          value={selectedCookie || cookieSearchQuery}
                          onChange={(e) => {
                            setCookieSearchQuery(e.target.value);
                            setSelectedCookie('');
                            setDepositCookies(false);
                          }}
                          onFocus={() => setIsDropdownOpen(true)}
                          className="w-full px-4 py-2 border border-gray-300 rounded-md pr-20"
                        />
                        <div className="absolute inset-y-0 right-0 flex items-center">
                          {selectedCookie && (
                            <button
                              type="button"
                              onClick={() => {
                                setSelectedCookie('');
                                setCookieSearchQuery('');
                                setDepositCookies(false);
                              }}
                              className="p-2 hover:text-red-600"
                              title="Clear selection"
                            >
                              <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd"/>
                              </svg>
                            </button>
                          )}
                          <button
                            type="button"
                            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                            className="p-2"
                          >
                            <svg className="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="none" stroke="currentColor">
                              <path d="M7 7l3-3 3 3m0 6l-3 3-3-3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                          </button>
                        </div>
                      </div>
                      {isDropdownOpen && (
                        <div className="absolute z-10 w-full mt-1 bg-white shadow-lg max-h-60 rounded-md py-1 text-base overflow-auto focus:outline-none sm:text-sm">
                          {availableCookies
                            .filter(cookie => 
                              cookie.name.toLowerCase().includes((selectedCookie || cookieSearchQuery).toLowerCase())
                            )
                            .map(cookie => (
                              <div
                                key={cookie.id}
                                className={`cursor-pointer select-none relative py-2 pl-3 pr-9 hover:bg-blue-50 ${
                                  selectedCookie === cookie.name ? 'bg-blue-50 text-blue-900' : 'text-gray-900'
                                }`}
                                onClick={() => {
                                  setSelectedCookie(cookie.name);
                                  setCookieSearchQuery('');
                                  setIsDropdownOpen(false);
                                }}
                              >
                                <span className="block truncate">{cookie.name}</span>
                                {selectedCookie === cookie.name && (
                                  <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-blue-600">
                                    <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                                    </svg>
                                  </span>
                                )}
                              </div>
                            ))}
                          {availableCookies.filter(cookie => 
                            cookie.name.toLowerCase().includes((selectedCookie || cookieSearchQuery).toLowerCase())
                          ).length === 0 && (
                            <div className="cursor-default select-none relative py-2 pl-3 pr-9 text-gray-500">
                              No cookies found
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                    <div className="mt-2">
                      <label className="flex items-center text-sm text-gray-600">
                        <input
                          type="checkbox"
                          id="advancedBrowserSettings"
                          checked={advancedBrowserSettings}
                          onChange={(e) => setAdvancedBrowserSettings(e.target.checked)}
                          className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                        />
                        <label htmlFor="advancedBrowserSettings" className="ml-2 block text-sm text-gray-700">
                          Use Advanced Browser Settings
                        </label>
                      </label>
                    </div>
                  </div>

                  <div className="flex justify-end mt-4">
                    <Button 
                      onClick={handleCreateScript}
                      className="bg-blue-600 text-white hover:bg-blue-700 mr-2"
                    >
                      Create Custom Script
                    </Button>
                    <Button 
                      onClick={closeCreateScoutModal}
                      className="bg-gray-400 text-white hover:bg-gray-500"
                    >
                      Cancel
                    </Button>
                  </div>
                </div>
              ) : activeCreateTab === '835backfill' ? (
                <div className="space-y-4">
                  <div className="bg-gray-50 p-6 rounded-lg border border-gray-200">
                    <h2 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                      <svg className="w-6 h-6 mr-2 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 17V7m0 10a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h2a2 2 0 012 2m0 10a2 2 0 002 2h2a2 2 0 002-2M9 7a2 2 0 012-2h2a2 2 0 012 2m0 10V7m0 10a2 2 0 002 2h2a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v5a2 2 0 002 2h6.5" />
                      </svg>
                      Create 835 Backfill
                    </h2>
                    <p className="text-gray-600 mb-4">
                      Run targeted backfills of 835 files from supported payer portals. Currently supports ECW, Echo, Zelis, Instamed, Payspan, Ashlink, Athena, Utah Medicaid, UHC, and Optum Pay.
                    </p>
                  </div>

                  <div>
                    <label htmlFor="backfill-portal" className="block text-sm font-medium text-gray-700 mb-2">
                      Portal <span className="text-red-500">*</span>
                    </label>
                    <select
                      id="backfill-portal"
                      value={selectedBackfillPortal}
                      onChange={(e) => { setSelectedBackfillPortal(e.target.value); setUhcCreateErrorMessage(''); setOptumCreateErrorMessage(''); }}
                      disabled={isCreatingUhc || isCreatingOptum}
                      className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      required
                    >
                      <option value="ECW">ECW</option>
                      <option value="ECW Posted">ECW Posted</option>
                      <option value="Echo">Echo</option>
                      <option value="Echo Date Range">Echo Date Range</option>
                      <option value="Echo Date Range EOB">Echo Date Range EOB</option>
                      <option value="Zelis">Zelis</option>
                      <option value="Instamed">Instamed</option>
                      <option value="Payspan">Payspan</option>
                      <option value="Ashlink">Ashlink</option>
                      <option value="Athena">Athena</option>
                      <option value="Utah Medicaid">Utah Medicaid</option>
                      <option value="UHC">UHC</option>
                      <option value="Optum Pay">Optum Pay</option>
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Site ID <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      value={siteId}
                      onChange={(e) => { setSiteId(e.target.value); setUtahDomainValue(''); setUhcCreateErrorMessage(''); setOptumCreateErrorMessage(''); }}
                      disabled={isCreatingUhc || isCreatingOptum}
                      className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      placeholder="Enter site ID..."
                      required
                    />
                  </div>

                  {!['UHC', 'Optum Pay'].includes(selectedBackfillPortal) && <>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Username <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                      className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      placeholder="Enter username..."
                      required
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Password <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      placeholder="Enter password..."
                      required
                    />
                  </div>

                  </>}

                  {selectedBackfillPortal === 'Utah Medicaid' && (
                    <UtahProviderTarget siteId={siteId} value={utahDomainValue} onChange={setUtahDomainValue} />
                  )}

                  {selectedBackfillPortal === 'Instamed' && (
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Corporate ID <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        value={corporateId}
                        onChange={(e) => setCorporateId(e.target.value)}
                        className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        placeholder="Enter corporate ID..."
                        required
                      />
                    </div>
                  )}

                  {(selectedBackfillPortal === 'Instamed' || selectedBackfillPortal === 'Zelis') && (
                    <div className="grid grid-cols-2 gap-4 mt-3">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          From Date {selectedBackfillPortal === 'Instamed' ? <span className="text-red-500">*</span> : '(optional)'}
                        </label>
                        <input
                          type="date"
                          value={fromDate}
                          onChange={(e) => setFromDate(e.target.value)}
                          className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                          required={selectedBackfillPortal === 'Instamed'}
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          To Date {selectedBackfillPortal === 'Instamed' ? <span className="text-red-500">*</span> : '(optional)'}
                        </label>
                        <input
                          type="date"
                          value={toDate}
                          onChange={(e) => setToDate(e.target.value)}
                          className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                          required={selectedBackfillPortal === 'Instamed'}
                        />
                      </div>
                    </div>
                  )}

                  {(selectedBackfillPortal === 'ECW Posted' || selectedBackfillPortal === 'Echo Date Range' || selectedBackfillPortal === 'Echo Date Range EOB' || selectedBackfillPortal === 'Athena' || selectedBackfillPortal === 'Utah Medicaid') && (
                    <div className="grid grid-cols-2 gap-4 mt-3">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          {selectedBackfillPortal === 'Utah Medicaid' ? 'Pay Cycle From Date' : 'From Date'} <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="date"
                          value={fromDate}
                          onChange={(e) => setFromDate(e.target.value)}
                          className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                          required
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          {selectedBackfillPortal === 'Utah Medicaid' ? 'Pay Cycle To Date' : 'To Date'} <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="date"
                          value={toDate}
                          onChange={(e) => setToDate(e.target.value)}
                          className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                          required
                        />
                      </div>
                    </div>
                  )}

                  {(selectedBackfillPortal === 'ECW' || selectedBackfillPortal === 'ECW Posted') && (
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Website URL <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        value={websiteUrl}
                        onChange={(e) => setWebsiteUrl(e.target.value)}
                        className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        placeholder="https://<tenant>.ecwcloud.com/mobiledoc/jsp/webemr/login/newLogin.jsp"
                        required
                      />
                    </div>
                  )}

                  {(selectedBackfillPortal === 'ECW' || selectedBackfillPortal === 'Echo' || selectedBackfillPortal === 'Zelis') && (
                    <div className="grid grid-cols-2 gap-4 mt-3">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Initial Page (optional)</label>
                        <input
                          type="number"
                          min="1"
                          value={initialPage}
                          onChange={(e) => setInitialPage(e.target.value)}
                          className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                          placeholder="1"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Num Pages (optional)</label>
                        <input
                          type="number"
                          min="1"
                          value={numPages}
                          onChange={(e) => setNumPages(e.target.value)}
                          className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                          placeholder="1"
                        />
                      </div>
                    </div>
                  )}

                  {selectedBackfillPortal === 'Payspan' && (
                    <div className="grid grid-cols-2 gap-4 mt-3">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          From Date (optional)
                        </label>
                        <input
                          type="date"
                          value={fromDate}
                          onChange={(e) => setFromDate(e.target.value)}
                          className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          To Date (optional)
                        </label>
                        <input
                          type="date"
                          value={toDate}
                          onChange={(e) => setToDate(e.target.value)}
                          className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                      </div>
                    </div>
                  )}

                  {selectedBackfillPortal === 'Ashlink' && (
                    <div className="grid grid-cols-2 gap-4 mt-3">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          From Date (optional)
                        </label>
                        <input
                          type="date"
                          value={fromDate}
                          onChange={(e) => setFromDate(e.target.value)}
                          className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          To Date (optional)
                        </label>
                        <input
                          type="date"
                          value={toDate}
                          onChange={(e) => setToDate(e.target.value)}
                          className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                      </div>
                    </div>
                  )}

                  {selectedBackfillPortal === 'Optum Pay' && <>
                    <OptumBackfillFields
                      loginId={optumLoginId}
                      fromDate={fromDate}
                      toDate={toDate}
                      disabled={isCreatingOptum}
                      onLoginIdChange={value => { setOptumLoginId(value); setOptumCreateErrorMessage(''); }}
                      onFromDateChange={value => { setFromDate(value); setOptumCreateErrorMessage(''); }}
                      onToDateChange={value => { setToDate(value); setOptumCreateErrorMessage(''); }}
                    />
                    {(siteId || optumLoginId || fromDate || toDate) && optumBackfillError({ siteId, loginId: optumLoginId, fromDate, toDate }) &&
                      <p role="status" className="text-sm text-red-700">{optumBackfillError({ siteId, loginId: optumLoginId, fromDate, toDate })}</p>}
                    {optumCreateErrorMessage && <p role="alert" className="text-sm text-red-700">{optumCreateErrorMessage}</p>}
                  </>}

                  {selectedBackfillPortal === 'UHC' && <>
                    <UhcBackfillFields fromDate={fromDate} toDate={toDate} disabled={isCreatingUhc}
                      onFromDateChange={value => { setFromDate(value); setUhcCreateErrorMessage(''); }}
                      onToDateChange={value => { setToDate(value); setUhcCreateErrorMessage(''); }} />
                    {(siteId || fromDate || toDate) && uhcBackfillError({ siteId, fromDate, toDate }) &&
                      <p role="status" className="text-sm text-red-700">{uhcBackfillError({ siteId, fromDate, toDate })}</p>}
                    {uhcCreateErrorMessage && <p role="alert" className="text-sm text-red-700">{uhcCreateErrorMessage}</p>}
                  </>}
                  {selectedBackfillPortal === 'Utah Medicaid' && fromDate && toDate && (
                    <p role="status" className="text-sm text-red-700">{utahBackfillError({ siteId, domainValue: utahDomainValue, username, password, fromDate, toDate })}</p>
                  )}
                  <div className="flex justify-end mt-4">
                    <Button
                      onClick={async () => {
                        const isUhc = selectedBackfillPortal === 'UHC';
                        const isOptum = selectedBackfillPortal === 'Optum Pay';
                        if (isUhc && uhcSubmissionInFlight.current) return;
                        if (isOptum && optumSubmissionInFlight.current) return;
                        if (isUhc) {
                          uhcSubmissionInFlight.current = true;
                          setIsCreatingUhc(true);
                          setUhcCreateErrorMessage('');
                        }
                        if (isOptum) {
                          optumSubmissionInFlight.current = true;
                          setIsCreatingOptum(true);
                          setOptumCreateErrorMessage('');
                        }
                        let requestSent = false;
                        try {
                          const jobType = selectedBackfillPortal === 'ECW'
                            ? 'ecw_835_backfill'
                            : selectedBackfillPortal === 'ECW Posted'
                            ? 'ecw_posted_835_backfill'
                            : selectedBackfillPortal === 'Echo'
                            ? 'echo_835_backfill'
                            : selectedBackfillPortal === 'Echo Date Range'
                            ? 'echo_date_range_835_backfill'
                            : selectedBackfillPortal === 'Echo Date Range EOB'
                            ? 'echo_date_range_eob_backfill'
                            : selectedBackfillPortal === 'Zelis'
                            ? 'zelis_835_backfill'
                            : selectedBackfillPortal === 'Instamed'
                            ? 'instamed_835_backfill'
                            : selectedBackfillPortal === 'Payspan'
                            ? 'payspan_835_backfill'
                            : selectedBackfillPortal === 'Ashlink'
                            ? 'ashlink_835_backfill'
                            : selectedBackfillPortal === 'Athena'
                            ? 'athena_835_backfill'
                            : selectedBackfillPortal === 'Utah Medicaid'
                            ? 'utah_medicaid_835_backfill'
                            : isUhc
                            ? UHC_BACKFILL_JOB_TYPE
                            : isOptum
                            ? OPTUM_BACKFILL_JOB_TYPE
                            : '';
                          if (!jobType) return;
                          
                          // Convert dates to MM/DD/YYYY format for Instamed
                          const formatDateForInstamed = (dateString) => {
                            if (!dateString) return undefined;
                            // Parse YYYY-MM-DD directly to avoid timezone shift issues
                            const [year, month, day] = dateString.split('-');
                            return `${month}/${day}/${year}`;
                          };
                          
                          // Reuse same formatter for Payspan (backend expects MM/DD/YYYY strings)
                          const formatDateForPayspan = formatDateForInstamed;
                          // Reuse same formatter for Ashlink
                          const formatDateForAshlink = formatDateForInstamed;
                          // Reuse same formatter for Zelis
                          const formatDateForZelis = formatDateForInstamed;
                          // Generic date formatter for all portals
                          const formatDate = formatDateForInstamed;
                          
                          const payload = {
                            job_type: jobType,
                            job_name: `${selectedBackfillPortal} 835 Backfill - Site ${siteId}`,
                            params: isUhc
                              ? buildUhcBackfillParams({ siteId, fromDate, toDate })
                              : isOptum
                              ? buildOptumBackfillParams({ siteId, loginId: optumLoginId, fromDate, toDate })
                              : {
                              site_id: siteId ? parseInt(siteId, 10) : undefined,
                              username: username || undefined,
                              password: password || undefined,
                              ...((selectedBackfillPortal === 'ECW' || selectedBackfillPortal === 'ECW Posted') ? { website_url: websiteUrl } : {}),
                              ...(selectedBackfillPortal === 'Instamed' ? { corporate_id: corporateId } : {}),
                              ...(selectedBackfillPortal === 'Instamed' ? { from_date: formatDateForInstamed(fromDate) } : {}),
                              ...(selectedBackfillPortal === 'Instamed' ? { to_date: formatDateForInstamed(toDate) } : {}),
                              ...(selectedBackfillPortal === 'Zelis' && fromDate ? { from_date: formatDateForZelis(fromDate) } : {}),
                              ...(selectedBackfillPortal === 'Zelis' && toDate ? { to_date: formatDateForZelis(toDate) } : {}),
                              ...(selectedBackfillPortal === 'Payspan' && fromDate ? { from_date: formatDateForPayspan(fromDate) } : {}),
                              ...(selectedBackfillPortal === 'Payspan' && toDate ? { to_date: formatDateForPayspan(toDate) } : {}),
                              ...(selectedBackfillPortal === 'Ashlink' && fromDate ? { from_date: formatDateForAshlink(fromDate) } : {}),
                              ...(selectedBackfillPortal === 'Ashlink' && toDate ? { to_date: formatDateForAshlink(toDate) } : {}),
                              ...(selectedBackfillPortal === 'ECW Posted' ? { from_date: formatDate(fromDate), to_date: formatDate(toDate) } : {}),
                              ...(selectedBackfillPortal === 'Echo Date Range' ? { from_date: formatDate(fromDate), to_date: formatDate(toDate) } : {}),
                              ...(selectedBackfillPortal === 'Echo Date Range EOB' ? { from_date: formatDate(fromDate), to_date: formatDate(toDate) } : {}),
                              ...(selectedBackfillPortal === 'Athena' ? { from_date: formatDate(fromDate), to_date: formatDate(toDate) } : {}),
                              ...(selectedBackfillPortal === 'Utah Medicaid' ? buildUtahBackfillParams({ siteId, domainValue: utahDomainValue, username, password, fromDate, toDate }) : {}),
                              ...(selectedBackfillPortal !== 'Utah Medicaid' && initialPage ? { initial_page: parseInt(initialPage, 10) } : {}),
                              ...(selectedBackfillPortal !== 'Utah Medicaid' && numPages ? { num_pages: parseInt(numPages, 10) } : {}),
                            },
                          };
                          requestSent = true;
                          const resp = await fetch(`${BASE_URL}/jobs/`, {
                            method: 'POST',
                            headers: {
                              'Authorization': `Bearer ${apiKey.key}`,
                              'Content-Type': 'application/json',
                            },
                            body: JSON.stringify(payload),
                          });
                          if (resp.ok) {
                            setIsCreateModalOpen(false);
                            setUsername('');
                            setPassword('');
                            setSiteId('');
                            setWebsiteUrl('');
                            setInitialPage('');
                            setNumPages('');
                            setCorporateId('');
                            setFromDate('');
                            setToDate('');
                            setUtahDomainValue('');
                            setOptumLoginId('');
                            fetch835Backfills();
                          } else {
                            const err = await resp.json();
                            if (isUhc) setUhcCreateErrorMessage(uhcCreateError(err.detail));
                            else if (isOptum) setOptumCreateErrorMessage(optumCreateError(err.detail));
                            else setError(typeof err.detail === 'string' ? err.detail : 'Failed to create 835 backfill');
                          }
                        } catch (e) {
                          console.error('[835 Backfills] Create error:', e);
                          if (isUhc) setUhcCreateErrorMessage(requestSent
                            ? 'Could not confirm job creation. Refresh the backfill list before retrying.'
                            : e.message);
                          else if (isOptum) setOptumCreateErrorMessage(requestSent
                            ? 'Could not confirm job creation. Refresh the backfill list before retrying.'
                            : e.message);
                          else setError(e.message || 'Failed to create 835 backfill. Please check your connection.');
                        } finally {
                          if (isUhc) {
                            uhcSubmissionInFlight.current = false;
                            setIsCreatingUhc(false);
                          }
                          if (isOptum) {
                            optumSubmissionInFlight.current = false;
                            setIsCreatingOptum(false);
                          }
                        }
                      }}
                      disabled={isCreatingUhc || isCreatingOptum || (selectedBackfillPortal === 'UHC'
                        ? !!uhcBackfillError({ siteId, fromDate, toDate })
                        : selectedBackfillPortal === 'Optum Pay'
                        ? !!optumBackfillError({ siteId, loginId: optumLoginId, fromDate, toDate })
                        : !siteId || !username || !password || ((selectedBackfillPortal === 'ECW' || selectedBackfillPortal === 'ECW Posted') && !websiteUrl) || (selectedBackfillPortal === 'Instamed' && !corporateId) || (['ECW Posted', 'Echo Date Range', 'Echo Date Range EOB', 'Instamed', 'Athena', 'Utah Medicaid'].includes(selectedBackfillPortal) && (!fromDate || !toDate)) || (selectedBackfillPortal === 'Utah Medicaid' && !!utahBackfillError({ siteId, domainValue: utahDomainValue, username, password, fromDate, toDate })))}
                      className="bg-blue-600 text-white hover:bg-blue-700 mr-2 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      {isCreatingUhc || isCreatingOptum ? 'Creating…' : 'Create 835 Backfill'}
                    </Button>
                    <Button
                      onClick={closeCreateScoutModal}
                      className="bg-gray-400 text-white hover:bg-gray-500"
                    >
                      Cancel
                    </Button>
                  </div>
                </div>
              ) : (
                <div className="space-y-4">
                  <div className="bg-gray-50 p-6 rounded-lg border border-gray-200">
                    <h2 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                      <svg className="w-6 h-6 mr-2 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 17V7m0 10a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h2a2 2 0 012 2m0 10a2 2 0 002 2h2a2 2 0 002-2M9 7a2 2 0 012-2h2a2 2 0 012 2m0 10V7m0 10a2 2 0 002 2h2a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v5a2 2 0 002 2h6.5" />
                      </svg>
                      Create 835 Scraper
                    </h2>
                    <p className="text-gray-600 mb-4">
                      Set up automated 835 file downloads from healthcare payers. Enter credentials and let our system handle the entire download process automatically.
                    </p>
                    <div className="flex items-center space-x-2 mb-4 bg-blue-50 p-3 rounded-lg border border-blue-200">
                      <svg className="w-5 h-5 text-blue-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      <p className="text-sm text-blue-600">
                        Securely automate 835 file downloads from supported healthcare payers including Instamed, Zelis, and more.
                      </p>
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Payer <span className="text-red-500">*</span>
                    </label>
                    <select
                      value={selectedPayer}
                      onChange={(e) => {
                        setSelectedPayer(e.target.value);
                      }}
                      className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      required
                    >
                      <option value="">Select a payer...</option>
                      <option value="INSTAMED">Instamed</option>
                      <option value="ZELIS">Zelis</option>
                      <option value="ECHO">Echo</option>
                      <option value="PAYSPAN">Payspan</option>
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Username (Optional)
                    </label>
                    <input
                      type="text"
                      value={username}
                      onChange={(e) => {
                        setUsername(e.target.value);
                      }}
                      className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      placeholder="Enter username if available..."
                    />
                    <p className="text-xs text-gray-500 mt-1">
                      Leave empty to use system-managed credentials
                    </p>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Password (Optional)
                    </label>
                    <input
                      type="password"
                      value={password}
                      onChange={(e) => {
                        setPassword(e.target.value);
                      }}
                      className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      placeholder="Enter password if available..."
                    />
                    <p className="text-xs text-gray-500 mt-1">
                      Leave empty to use system-managed credentials
                    </p>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Corporate ID (Optional)
                    </label>
                    <input
                      type="text"
                      value={corporateId}
                      onChange={(e) => {
                        setCorporateId(e.target.value);
                      }}
                      className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      placeholder="Enter corporate ID if required..."
                    />
                    <p className="text-xs text-gray-500 mt-1">
                      Required for some payers like Instamed
                    </p>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Site ID <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      value={siteId}
                      onChange={(e) => {
                        setSiteId(e.target.value);
                      }}
                      className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      placeholder="Enter site ID..."
                      required
                    />
                    <p className="text-xs text-gray-500 mt-1">
                      Required for file naming and identification
                    </p>
                  </div>

                  <div className="flex justify-end mt-4">
                    <Button 
                      onClick={handleCreate835Scraper}
                      disabled={!selectedPayer || !siteId}
                      className="bg-blue-600 text-white hover:bg-blue-700 mr-2 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      Create 835 Scraper
                    </Button>
                    <Button 
                      onClick={closeCreateScoutModal}
                      className="bg-gray-400 text-white hover:bg-gray-500"
                    >
                      Cancel
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </Card>
        </div>
      )}

      {/* View Modal */}
      {isViewModalOpen && (selectedScout || selectedScript) && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center"
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              closeViewModal();
            }
          }}
        >
          <Card 
            className="w-full max-w-4xl max-h-[80vh] flex flex-col overflow-hidden"
          >
            <div className="p-6 flex-shrink-0">
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-2xl font-bold text-gray-900">
                  {selectedScout ? 'View Scout Session' : 'View Custom Script'}
                </h2>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    closeViewModal();
                  }}
                  className="text-gray-500 hover:text-gray-700"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
              <div className="flex border-b border-gray-200">
                <button
                  onClick={() => setActiveTab('details')}
                  className={`px-4 py-2 ${activeTab === 'details' ? 'border-b-2 border-blue-500 text-blue-600' : 'text-gray-500'}`}
                >
                  {selectedScout ? 'View Prompt/Response' : 'View Script/Result'}
                </button>
                {selectedScout && (
                  <>
                    <button
                      onClick={() => setActiveTab('live')}
                      className={`px-4 py-2 ${activeTab === 'live' ? 'border-b-2 border-blue-500 text-blue-600' : 'text-gray-500'}`}
                    >
                      Live View
                    </button>
                    <button
                      onClick={() => setActiveTab('cancel')}
                      className={`px-4 py-2 ${activeTab === 'cancel' ? 'border-b-2 border-blue-500 text-blue-600' : 'text-gray-500'}`}
                    >
                      Cancel Scout
                    </button>
                  </>
                )}
                {!selectedScout && (
                  <button
                    onClick={() => {
                      setActiveTab('recording');
                      fetchRecording(selectedScript.id, 'custom');
                    }}
                    className={`px-4 py-2 ${activeTab === 'recording' ? 'border-b-2 border-blue-500 text-blue-600' : 'text-gray-500'}`}
                  >
                    Recording
                  </button>
                )}
              </div>
            </div>

            <div className="p-6 pt-0 overflow-y-auto flex-grow">
              {activeTab === 'details' && selectedScout && (
                <div className="prose">
                  <h3 className="text-lg font-semibold mb-2">User Prompt</h3>
                  <p className="text-gray-600">{selectedScout.user_prompt}</p>
                  {selectedScout.operator_response && (
                    <>
                      <h3 className="text-lg font-semibold mb-2 mt-6">Scout Response</h3>
                      <p className="text-gray-600">{selectedScout.operator_response}</p>
                    </>
                  )}
                  {selectedScout.comments && (
                    <>
                      <h3 className="text-lg font-semibold mb-2 mt-6">Comments</h3>
                      <p className="text-gray-600">{selectedScout.comments}</p>
                    </>
                  )}
                  {selectedScout.status === 'IN_PROGRESS' && (
                    <div className="mt-6 flex items-center justify-center">
                      <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
                      <p className="ml-3 text-gray-600">Processing your request...</p>
                    </div>
                  )}
                </div>
              )}

              {activeTab === 'details' && selectedScript && (
                <div className="space-y-6">
                  <div>
                    <h3 className="text-lg font-semibold mb-2">Script</h3>
                    <pre className="bg-gray-50 p-4 rounded-lg overflow-x-auto">
                      <code className="text-sm">{selectedScript.script}</code>
                    </pre>
                  </div>
                  {selectedScript.result && (
                    <div>
                      <h3 className="text-lg font-semibold mb-2">Result</h3>
                      <pre className="bg-gray-50 p-4 rounded-lg overflow-x-auto">
                        <code className="text-sm">{selectedScript.result}</code>
                      </pre>
                    </div>
                  )}
                  <div>
                    <h3 className="text-lg font-semibold mb-2">Status</h3>
                    <span className={`inline-block px-2 py-1 text-sm font-medium rounded-md ${
                      selectedScript.status === 'COMPLETED' ? 'bg-green-100 text-green-700' :
                      selectedScript.status === 'IN_PROGRESS' ? 'bg-blue-100 text-blue-700' :
                      selectedScript.status === 'ERROR' ? 'bg-red-100 text-red-700' :
                      'bg-gray-100 text-gray-700'
                    }`}>
                      {selectedScript.status}
                    </span>
                  </div>
                  {selectedScript.status === 'IN_PROGRESS' && (
                    <div className="flex items-center justify-center">
                      <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
                      <p className="ml-3 text-gray-600">Processing your script...</p>
                    </div>
                  )}
                </div>
              )}

              {activeTab === 'live' && selectedScout && (
                <div className="mt-4">
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h3 className="text-lg font-semibold mb-4">
                      {selectedScout.status === 'IN_PROGRESS' ? 'Live View' : 'Recording'}
                    </h3>
                    {selectedScout.status === 'IN_PROGRESS' ? (
                      urls && urls.length > 0 ? (
                        <div className="space-y-4">
                          <div className="flex space-x-2 border-b border-gray-200">
                            {urls.map((url, index) => (
                              <button
                                key={index}
                                onClick={() => setActiveUrlTab(index)}
                                className={`px-4 py-2 text-sm font-medium rounded-t-lg ${
                                  activeUrlTab === index
                                    ? 'bg-white text-blue-600 border-b-2 border-blue-500'
                                    : 'text-gray-500 hover:text-gray-700'
                                }`}
                              >
                                URL {index + 1}
                              </button>
                            ))}
                          </div>
                          <div className="bg-white rounded-lg shadow-sm border border-gray-200">
                            <div className="p-2 bg-gray-50 border-b border-gray-200 flex items-center justify-between">
                              <span className="text-sm text-gray-600 truncate max-w-2xl">
                                {urls[activeUrlTab]}
                              </span>
                              <a
                                href={urls[activeUrlTab]}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-600 hover:text-blue-800 text-sm"
                              >
                                Open in New Tab
                              </a>
                            </div>
                            <div className="w-full h-[600px] relative">
                              <iframe
                                src={urls[activeUrlTab]}
                                className="w-full h-full border-0"
                                title={`Live View ${activeUrlTab + 1}`}
                                sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
                              />
                            </div>
                          </div>
                        </div>
                      ) : (
                        <p className="text-gray-600">Waiting for URLs to be available...</p>
                      )
                    ) : (
                      <div className="bg-white rounded-lg shadow-sm border border-gray-200">
                        <div id="recording-player-scout" className="w-full">
                          {!recording && (
                            <p className="text-gray-600 p-4">No recording available for this session.</p>
                          )}
                        </div>
                      </div>
                    )}
                    {selectedScout.status === 'IN_PROGRESS' && (
                      <div className="mt-4 flex items-center justify-center">
                        <div className="inline-block animate-spin rounded-full h-6 w-6 border-b-2 border-gray-900"></div>
                        <p className="ml-3 text-gray-600">Polling for updates...</p>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {activeTab === 'cancel' && selectedScout && (
                <div className="text-center">
                  <p className="text-gray-600 mb-4">Are you sure you want to cancel this Scout session?</p>
                  <Button
                    onClick={handleCancelScout}
                    className="!bg-red-600 hover:!bg-red-700"
                  >
                    Cancel Scout Session
                  </Button>
                </div>
              )}

              {activeTab === 'recording' && selectedScript && (
                <div className="p-6">
                  <div id="recording-player-script" className="w-full">
                    {!recording && (
                      <p className="text-gray-600">No recording available for this session.</p>
                    )}
                  </div>
                </div>
              )}
            </div>
          </Card>
        </div>
      )}

      {/* Example Modal */}
      {isExampleModalOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              setIsExampleModalOpen(false);
            }
          }}
        >
          <Card className="w-full max-w-5xl max-h-[90vh] flex flex-col overflow-hidden">
            <div className="p-6 flex-shrink-0 border-b border-gray-200 flex justify-between items-center bg-indigo-50">
              <h2 className="text-2xl font-bold text-indigo-900">Write Once, Run Anywhere</h2>
              <button
                onClick={() => setIsExampleModalOpen(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            
            <div className="p-6 overflow-y-auto flex-grow">
              <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden mb-8">
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                    <svg className="w-6 h-6 text-indigo-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                    </svg>
                    The Portable Script Concept
                  </h3>
                  <p className="text-gray-700 mb-6">
                    Our platform uses a modular approach that lets you write Playwright scripts that work both locally during development and in our cloud environment without changes. This approach offers significant advantages:
                  </p>
                  
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                    <div className="bg-indigo-50 p-4 rounded-lg border border-indigo-100">
                      <div className="flex items-center mb-2">
                        <svg className="w-5 h-5 text-indigo-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4" />
                        </svg>
                        <h4 className="font-medium text-indigo-800">Flexible Development</h4>
                      </div>
                      <p className="text-sm text-indigo-700 mt-2">
                        Develop and test on your local machine with immediate feedback before deploying to our cloud platform.
                      </p>
                    </div>
                    
                    <div className="bg-indigo-50 p-4 rounded-lg border border-indigo-100">
                      <div className="flex items-center mb-2">
                        <svg className="w-5 h-5 text-indigo-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                        </svg>
                        <h4 className="font-medium text-indigo-800">Seamless Transition</h4>
                      </div>
                      <p className="text-sm text-indigo-700 mt-2">
                        No code changes needed when moving between local development and cloud execution.
                      </p>
                    </div>
                    
                    <div className="bg-indigo-50 p-4 rounded-lg border border-indigo-100">
                      <div className="flex items-center mb-2">
                        <svg className="w-5 h-5 text-indigo-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                        </svg>
                        <h4 className="font-medium text-indigo-800">Reusable Scripts</h4>
                      </div>
                      <p className="text-sm text-indigo-700 mt-2">
                        Build a library of scripts that work across environments, saving development time and effort.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="mb-8">
                <h3 className="text-xl font-bold text-gray-900 mb-4">How It Works</h3>
                
                <div className="bg-white rounded-lg border border-gray-200 overflow-hidden mb-6">
                  <div className="p-5 border-b border-gray-200 bg-indigo-50">
                    <h4 className="font-medium text-indigo-900 flex items-center">
                      <div className="bg-indigo-600 text-white rounded-full w-6 h-6 flex items-center justify-center mr-2">
                        <span>1</span>
                      </div>
                      You Define a Single Function
                    </h4>
                  </div>
                  <div className="p-5">
                    <p className="text-gray-700 mb-3">
                      Write a <code className="bg-gray-100 px-1 rounded">run_script</code> function that takes a browser context parameter:
                    </p>
                    <div className="bg-gray-800 text-indigo-300 p-4 rounded-md font-mono text-sm overflow-x-auto mb-3 whitespace-pre">
{`async def run_script(browser_context):
    # Create pages from the provided context
    page = await browser_context.new_page()
    
    try:
        # Your automation logic here
        await page.goto('https://example.com')
        title = await page.title()
        
        # Take a screenshot
        await page.screenshot(path=f"{session_dir}/screenshot.png")
        
        # Return results
        return {"title": title, "url": page.url}
    finally:
        # Always close the page when done
        await page.close()`}
                    </div>
                    <div className="flex items-start mt-2">
                      <svg className="w-4 h-4 text-indigo-500 mt-0.5 mr-1 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                      </svg>
                      <div>
                        <p className="text-sm text-gray-700">
                          <span className="font-medium">Important:</span> This is the <strong>only</strong> function you need to define - everything else is handled for you.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                  <div className="bg-white rounded-lg border border-gray-200 overflow-hidden h-full">
                    <div className="p-4 border-b border-gray-200 bg-indigo-50">
                      <h4 className="font-medium text-indigo-900 flex items-center">
                        <div className="bg-indigo-600 text-white rounded-full w-6 h-6 flex items-center justify-center mr-2">
                          <span>2A</span>
                        </div>
                        Local Development
                      </h4>
                    </div>
                    <div className="p-4">
                      <p className="text-gray-700 mb-3">
                        During development, wrap it with local Playwright setup:
                      </p>
                      <div className="bg-gray-800 text-indigo-300 p-4 rounded-md font-mono text-sm overflow-x-auto whitespace-pre">
{`import asyncio
from playwright.async_api import async_playwright

# Set up session_dir for local testing
session_dir = "./downloads"
os.makedirs(session_dir, exist_ok=True)

async def local_test():
    async with async_playwright() as p:
        browser = await p.chromium.launch()
        context = await browser.new_context()
        
        # Call your function with local context
        result = await run_script(context)
        print("Result:", result)
        
        await browser.close()

# Run the test
asyncio.run(local_test())`}
                      </div>
                      <div className="bg-green-50 border border-green-100 rounded-md p-3 mt-3">
                        <div className="flex items-start">
                          <svg className="w-5 h-5 text-green-500 mt-0.5 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                          </svg>
                          <div>
                            <p className="text-sm text-green-700">
                              <span className="font-medium">Benefits:</span> Quick iteration, immediate feedback, use your favorite debugger
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div className="bg-white rounded-lg border border-gray-200 overflow-hidden h-full">
                    <div className="p-4 border-b border-gray-200 bg-indigo-50">
                      <h4 className="font-medium text-indigo-900 flex items-center">
                        <div className="bg-indigo-600 text-white rounded-full w-6 h-6 flex items-center justify-center mr-2">
                          <span>2B</span>
                        </div>
                        Cloud Execution
                      </h4>
                    </div>
                    <div className="p-4">
                      <p className="text-gray-700 mb-3">
                        For cloud execution, just upload the same <code className="bg-gray-100 px-1 rounded">run_script</code> function:
                      </p>
                      <div className="bg-gray-800 text-indigo-300 p-4 rounded-md font-mono text-sm overflow-x-auto h-[238px] flex items-center justify-center">
                        <div className="text-center">
                          <svg className="w-16 h-16 mx-auto mb-2 text-indigo-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                          </svg>
                          <p className="text-base">Upload your script with <code className="bg-gray-700 px-1 rounded">run_script()</code> function</p>
                          <p className="text-xs text-indigo-400 mt-2">Our system handles the rest - browser setup, context creation, etc.</p>
                        </div>
                      </div>
                      <div className="bg-green-50 border border-green-100 rounded-md p-3 mt-3">
                        <div className="flex items-start">
                          <svg className="w-5 h-5 text-green-500 mt-0.5 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                          </svg>
                          <div>
                            <p className="text-sm text-green-700">
                              <span className="font-medium">Benefits:</span> Scalable cloud infrastructure, no local setup needed, consistent environment
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="mb-8">
                <h3 className="text-xl font-bold text-gray-900 mb-4">Complete Example</h3>
                
                <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
                  <div className="p-5">
                    <p className="text-gray-700 mb-4">
                      Here's a complete example script that logs into a website, searches for a product, and captures screenshots:
                    </p>
                    
                    <div className="bg-gray-800 text-green-400 p-4 rounded-md font-mono text-sm overflow-x-auto whitespace-pre">
{`async def run_script(browser_context):
    """
    Example Playwright script that logs into a website and searches for products.
    
    Args:
        browser_context: Browser context (provided by our system or your local setup)
    
    Returns:
        Dictionary with results summary
    """
    from datetime import datetime
    
    # Helper function to save screenshots with timestamps
    async def save_screenshot(page, name):
        timestamp = datetime.now().strftime("%Y%m%d_%H%M%S")
        path = f"{session_dir}/{name}_{timestamp}.png"
        await page.screenshot(path=path)
        print(f"Screenshot saved: {path}")
        return path
    
    # Create a new page from the provided context
    page = await browser_context.new_page()
    
    screenshots = []
    
    try:
        # Navigate to the website
        await page.goto('https://demo.opencart.com/')
        screenshots.append(await save_screenshot(page, "homepage"))
        
        # Search for a product
        await page.fill('input[name="search"]', 'phone')
        await page.press('input[name="search"]', 'Enter')
        
        # Wait for search results to load
        await page.wait_for_selector('.product-layout')
        screenshots.append(await save_screenshot(page, "search_results"))
        
        # Get product titles
        product_elements = await page.query_selector_all('.product-layout .caption h4 a')
        products = []
        
        for element in product_elements:
            product_name = await element.inner_text()
            products.append(product_name)
        
        # Click on the first product if available
        if product_elements:
            await product_elements[0].click()
            await page.wait_for_selector('#product')
            screenshots.append(await save_screenshot(page, "product_details"))
        
        # Return a summary of the automation
        return {
            "status": "success",
            "products_found": len(products),
            "product_names": products,
            "screenshots": screenshots
        }
        
    except Exception as e:
        print(f"Error during execution: {str(e)}")
        await save_screenshot(page, "error_state")
        return {
            "status": "error",
            "message": str(e)
        }
    finally:
        # Always close the page when done
        await page.close()`}
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="mb-4">
                <h3 className="text-xl font-bold text-gray-900 mb-4">Testing Locally</h3>
                <p className="text-gray-700 mb-4">
                  To test your script locally before uploading to our platform, append this code to your file:
                </p>
                
                <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
                  <div className="p-5">
                    <div className="bg-gray-800 text-green-400 p-4 rounded-md font-mono text-sm overflow-x-auto whitespace-pre">
{`# ------- LOCAL TESTING CODE (REMOVE BEFORE UPLOADING) -------
# Run this section to test your script locally

if __name__ == "__main__":
    import asyncio
    import os
    from playwright.async_api import async_playwright
    
    # Create session_dir for local testing
    session_dir = "./downloads"
    os.makedirs(session_dir, exist_ok=True)
    
    async def test_locally():
        print("Starting local test...")
        async with async_playwright() as playwright:
            # Launch a browser locally
            browser = await playwright.chromium.launch(headless=False)
            context = await browser.new_context()
            
            try:
                # Run your script with this context
                result = await run_script(context)
                print("Script completed with result:", result)
            finally:
                await browser.close()
                print("Local test completed")
    
    # Run the local test
    asyncio.run(test_locally())`}
                    </div>
                    <div className="flex items-start mt-2">
                      <svg className="w-4 h-4 text-indigo-500 mt-0.5 mr-1 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                      </svg>
                      <div>
                        <p className="text-sm text-gray-700">
                          <span className="font-medium">Important:</span> Remove or comment out this section before uploading to our platform. You only need to upload the <code className="bg-gray-100 px-1 rounded">run_script()</code> function and any helper functions it uses.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="mt-6 flex justify-end gap-4">
                <Button 
                  onClick={() => {
                    const exampleScript = `async def run_script(browser_context):
    """
    Example Playwright script that logs into a website and searches for products.
    
    Args:
        browser_context: Browser context (provided by our system or your local setup)
    
    Returns:
        Dictionary with results summary
    """
    from datetime import datetime
    
    # Helper function to save screenshots with timestamps
    async def save_screenshot(page, name):
        timestamp = datetime.now().strftime("%Y%m%d_%H%M%S")
        path = f"{session_dir}/{name}_{timestamp}.png"
        await page.screenshot(path=path)
        print(f"Screenshot saved: {path}")
        return path
    
    # Create a new page from the provided context
    page = await browser_context.new_page()
    
    screenshots = []
    
    try:
        # Navigate to the website
        await page.goto('https://demo.opencart.com/')
        screenshots.append(await save_screenshot(page, "homepage"))
        
        # Search for a product
        await page.fill('input[name="search"]', 'phone')
        await page.press('input[name="search"]', 'Enter')
        
        # Wait for search results to load
        await page.wait_for_selector('.product-layout')
        screenshots.append(await save_screenshot(page, "search_results"))
        
        # Get product titles
        product_elements = await page.query_selector_all('.product-layout .caption h4 a')
        products = []
        
        for element in product_elements:
            product_name = await element.inner_text()
            products.append(product_name)
        
        # Click on the first product if available
        if product_elements:
            await product_elements[0].click()
            await page.wait_for_selector('#product')
            screenshots.append(await save_screenshot(page, "product_details"))
        
        # Return a summary of the automation
        return {
            "status": "success",
            "products_found": len(products),
            "product_names": products,
            "screenshots": screenshots
        }
        
    except Exception as e:
        print(f"Error during execution: {str(e)}")
        await save_screenshot(page, "error_state")
        return {
            "status": "error",
            "message": str(e)
        }
    finally:
        # Always close the page when done
        await page.close()`;
                    setNewScript(exampleScript);
                    setIsExampleModalOpen(false);
                  }}
                  className="mr-4"
                >
                  Use This Example
                </Button>
                <Button 
                  onClick={() => setIsExampleModalOpen(false)}
                  className="!bg-gray-500"
                >
                  Close
                </Button>
              </div>
            </div>
          </Card>
        </div>
      )}

      {/* API Documentation Modal */}
      {isApiDocsModalOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              setIsApiDocsModalOpen(false);
            }
          }}
        >
          <Card className="w-full max-w-6xl max-h-[90vh] flex flex-col overflow-hidden">
            <div className="p-6 flex-shrink-0 border-b border-gray-200 flex justify-between items-center bg-blue-50">
              <h2 className="text-2xl font-bold text-blue-900">835 Scraper API Documentation</h2>
              <button
                onClick={() => setIsApiDocsModalOpen(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            
            <div className="p-6 overflow-y-auto flex-grow">
              {/* Overview Section */}
              <div className="mb-8">
                <h3 className="text-xl font-bold text-gray-900 mb-4">Overview</h3>
                <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
                  <p className="text-gray-700 mb-3">
                    The 835 Scraper API allows you to automate the download of 835 files from healthcare payers. 
                    This API provides endpoints to create, list, and manage 835 scraper sessions that automatically 
                    log into payer portals and download 835 files.
                  </p>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
                    <div className="bg-white p-3 rounded border border-blue-100">
                      <h4 className="font-medium text-blue-800 mb-2">Supported Payers</h4>
                      <ul className="text-sm text-blue-700 space-y-1">
                        <li>• Instamed</li>
                        <li>• Zelis</li>
                        <li>• Echo</li>
                        <li>• Payspan</li>
                      </ul>
                    </div>
                    <div className="bg-white p-3 rounded border border-blue-100">
                      <h4 className="font-medium text-blue-800 mb-2">Authentication</h4>
                      <p className="text-sm text-blue-700">
                        All endpoints require Bearer token authentication using your API key in the Authorization header.
                      </p>
                    </div>
                    <div className="bg-white p-3 rounded border border-blue-100">
                      <h4 className="font-medium text-blue-800 mb-2">Base URL</h4>
                      <p className="text-sm text-blue-700 font-mono">
                        {BASE_URL}/scout
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Endpoints Section */}
              <div className="space-y-8">
                {/* Create 835 Scraper Endpoint */}
                <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
                  <div className="p-5 border-b border-gray-200 bg-green-50">
                    <h4 className="font-bold text-green-900 flex items-center">
                      <span className="bg-green-600 text-white px-2 py-1 rounded text-sm mr-3">POST</span>
                      Create 835 Scraper
                    </h4>
                  </div>
                  <div className="p-5">
                    <div className="mb-4">
                      <h5 className="font-medium text-gray-900 mb-2">Endpoint</h5>
                      <code className="bg-gray-100 px-2 py-1 rounded text-sm">POST /scout/create_835_scraper</code>
                    </div>
                    
                    <div className="mb-4">
                      <h5 className="font-medium text-gray-900 mb-2">Description</h5>
                      <p className="text-gray-700">
                        Creates a new 835 scraper session that will automatically log into the specified payer portal 
                        and download 835 files. The scraper runs asynchronously and will update its status as it progresses.
                      </p>
                    </div>

                    <div className="mb-4">
                      <h5 className="font-medium text-gray-900 mb-2">Request Body</h5>
                      <div className="bg-gray-800 text-green-400 p-4 rounded-md font-mono text-sm overflow-x-auto">
{`{
  "payer": "INSTAMED",           // Required: Payer type (INSTAMED, ZELIS, ECHO, PAYSPAN)
  "site_id": "12345",           // Required: Site ID for file naming
  "username": "user@example.com", // Optional: Username for payer portal
  "password": "password123",    // Optional: Password for payer portal  
  "corporate_id": "CORP001"     // Optional: Corporate ID (required for some payers)
}`}
                      </div>
                    </div>

                    <div className="mb-4">
                      <h5 className="font-medium text-gray-900 mb-2">Response</h5>
                      <div className="bg-gray-800 text-green-400 p-4 rounded-md font-mono text-sm overflow-x-auto">
{`{
  "id": 123,
  "payer": "INSTAMED",
  "site_id": 12345,
  "username": "user@example.com",
  "password": "password123",
  "corporate_id": "CORP001",
  "status": "QUEUED",
  "result": null,
  "created_at": "2024-01-15T10:30:00Z",
  "updated_at": "2024-01-15T10:30:00Z"
}`}
                      </div>
                    </div>

                    <div className="mb-4">
                      <h5 className="font-medium text-gray-900 mb-2">Status Values</h5>
                      <div className="grid grid-cols-2 gap-4">
                        <div>
                          <span className="inline-block px-2 py-1 text-xs font-medium rounded-md bg-yellow-100 text-yellow-700">QUEUED</span>
                          <p className="text-sm text-gray-600 mt-1">Scraper is queued for processing</p>
                        </div>
                        <div>
                          <span className="inline-block px-2 py-1 text-xs font-medium rounded-md bg-blue-100 text-blue-700">IN_PROGRESS</span>
                          <p className="text-sm text-gray-600 mt-1">Scraper is currently running</p>
                        </div>
                        <div>
                          <span className="inline-block px-2 py-1 text-xs font-medium rounded-md bg-green-100 text-green-700">COMPLETED</span>
                          <p className="text-sm text-gray-600 mt-1">Scraper completed successfully</p>
                        </div>
                        <div>
                          <span className="inline-block px-2 py-1 text-xs font-medium rounded-md bg-red-100 text-red-700">ERROR</span>
                          <p className="text-sm text-gray-600 mt-1">Scraper encountered an error</p>
                        </div>
                      </div>
                    </div>

                    <div className="mb-4">
                      <h5 className="font-medium text-gray-900 mb-2">Example cURL</h5>
                      <div className="bg-gray-800 text-green-400 p-4 rounded-md font-mono text-sm overflow-x-auto">
{`curl -X POST "${BASE_URL}/scout/create_835_scraper" \\
  -H "Authorization: Bearer YOUR_API_KEY" \\
  -H "Content-Type: application/json" \\
  -d '{
    "payer": "INSTAMED",
    "site_id": "12345",
    "username": "user@example.com",
    "password": "password123",
    "corporate_id": "CORP001"
  }'`}
                      </div>
                    </div>
                  </div>
                </div>

                {/* List 835 Scrapers Endpoint */}
                <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
                  <div className="p-5 border-b border-gray-200 bg-blue-50">
                    <h4 className="font-bold text-blue-900 flex items-center">
                      <span className="bg-blue-600 text-white px-2 py-1 rounded text-sm mr-3">GET</span>
                      List 835 Scrapers
                    </h4>
                  </div>
                  <div className="p-5">
                    <div className="mb-4">
                      <h5 className="font-medium text-gray-900 mb-2">Endpoint</h5>
                      <code className="bg-gray-100 px-2 py-1 rounded text-sm">GET /scout/list_835_scrapers</code>
                    </div>
                    
                    <div className="mb-4">
                      <h5 className="font-medium text-gray-900 mb-2">Description</h5>
                      <p className="text-gray-700">
                        Retrieves a paginated list of 835 scraper sessions for the authenticated user. 
                        Results are sorted by creation date in descending order.
                      </p>
                    </div>

                    <div className="mb-4">
                      <h5 className="font-medium text-gray-900 mb-2">Query Parameters</h5>
                      <div className="bg-gray-50 p-4 rounded border">
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                          <div>
                            <code className="text-sm font-medium">limit</code>
                            <p className="text-xs text-gray-600 mt-1">Maximum number of records (default: 10)</p>
                          </div>
                          <div>
                            <code className="text-sm font-medium">offset</code>
                            <p className="text-xs text-gray-600 mt-1">Number of records to skip (default: 0)</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="mb-4">
                      <h5 className="font-medium text-gray-900 mb-2">Response</h5>
                      <div className="bg-gray-800 text-green-400 p-4 rounded-md font-mono text-sm overflow-x-auto">
{`[
  {
    "id": 123,
    "payer": "INSTAMED",
    "site_id": 12345,
    "username": "user@example.com",
    "password": "password123",
    "corporate_id": "CORP001",
    "status": "COMPLETED",
    "result": "Successfully downloaded 5 files",
    "created_at": "2024-01-15T10:30:00Z",
    "updated_at": "2024-01-15T10:35:00Z"
  },
  {
    "id": 122,
    "payer": "ZELIS",
    "site_id": 67890,
    "username": null,
    "password": null,
    "corporate_id": null,
    "status": "IN_PROGRESS",
    "result": null,
    "created_at": "2024-01-15T10:25:00Z",
    "updated_at": "2024-01-15T10:25:00Z"
  }
]`}
                      </div>
                    </div>

                    <div className="mb-4">
                      <h5 className="font-medium text-gray-900 mb-2">Example cURL</h5>
                      <div className="bg-gray-800 text-green-400 p-4 rounded-md font-mono text-sm overflow-x-auto">
{`curl -X GET "${BASE_URL}/scout/list_835_scrapers?limit=10&offset=0" \\
  -H "Authorization: Bearer YOUR_API_KEY"`}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Payer-Specific Requirements */}
                <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
                  <div className="p-5 border-b border-gray-200 bg-purple-50">
                    <h4 className="font-bold text-purple-900">Payer-Specific Requirements</h4>
                  </div>
                  <div className="p-5">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div className="border border-purple-200 rounded-lg p-4">
                        <h5 className="font-medium text-purple-800 mb-3">Instamed</h5>
                        <ul className="text-sm text-purple-700 space-y-2">
                          <li>• <strong>Required:</strong> corporate_id</li>
                          <li>• <strong>Optional:</strong> username, password</li>
                          <li>• Uses system-managed credentials if not provided</li>
                        </ul>
                      </div>
                      <div className="border border-purple-200 rounded-lg p-4">
                        <h5 className="font-medium text-purple-800 mb-3">Zelis</h5>
                        <ul className="text-sm text-purple-700 space-y-2">
                          <li>• <strong>Optional:</strong> username, password</li>
                          <li>• Uses system-managed credentials if not provided</li>
                          <li>• No corporate_id required</li>
                        </ul>
                      </div>
                      <div className="border border-purple-200 rounded-lg p-4">
                        <h5 className="font-medium text-purple-800 mb-3">Echo</h5>
                        <ul className="text-sm text-purple-700 space-y-2">
                          <li>• <strong>Optional:</strong> username, password, corporate_id</li>
                          <li>• Uses system-managed credentials if not provided</li>
                        </ul>
                      </div>
                      <div className="border border-purple-200 rounded-lg p-4">
                        <h5 className="font-medium text-purple-800 mb-3">Payspan</h5>
                        <ul className="text-sm text-purple-700 space-y-2">
                          <li>• <strong>Optional:</strong> username, password, corporate_id</li>
                          <li>• Uses system-managed credentials if not provided</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Error Handling */}
                <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
                  <div className="p-5 border-b border-gray-200 bg-red-50">
                    <h4 className="font-bold text-red-900">Error Handling</h4>
                  </div>
                  <div className="p-5">
                    <div className="space-y-4">
                      <div>
                        <h5 className="font-medium text-gray-900 mb-2">Common HTTP Status Codes</h5>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                          <div className="border border-red-200 rounded p-3">
                            <code className="text-red-600 font-medium">400 Bad Request</code>
                            <p className="text-sm text-gray-600 mt-1">Invalid request body or missing required fields</p>
                          </div>
                          <div className="border border-red-200 rounded p-3">
                            <code className="text-red-600 font-medium">401 Unauthorized</code>
                            <p className="text-sm text-gray-600 mt-1">Invalid or missing API key</p>
                          </div>
                          <div className="border border-red-200 rounded p-3">
                            <code className="text-red-600 font-medium">422 Validation Error</code>
                            <p className="text-sm text-gray-600 mt-1">Invalid payer type or data format</p>
                          </div>
                          <div className="border border-red-200 rounded p-3">
                            <code className="text-red-600 font-medium">500 Internal Server Error</code>
                            <p className="text-sm text-gray-600 mt-1">Server error during processing</p>
                          </div>
                        </div>
                      </div>
                      
                      <div>
                        <h5 className="font-medium text-gray-900 mb-2">Error Response Format</h5>
                        <div className="bg-gray-800 text-red-400 p-4 rounded-md font-mono text-sm overflow-x-auto">
{`{
  "detail": "Error message describing what went wrong"
}`}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Best Practices */}
                <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
                  <div className="p-5 border-b border-gray-200 bg-green-50">
                    <h4 className="font-bold text-green-900">Best Practices</h4>
                  </div>
                  <div className="p-5">
                    <div className="space-y-4">
                      <div className="flex items-start">
                        <svg className="w-5 h-5 text-green-500 mt-0.5 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <div>
                          <h5 className="font-medium text-gray-900">Polling for Status Updates</h5>
                          <p className="text-sm text-gray-600 mt-1">
                            Use the list endpoint to poll for status updates. Scrapers typically complete within 5-15 minutes depending on the payer and number of files.
                          </p>
                        </div>
                      </div>
                      
                      <div className="flex items-start">
                        <svg className="w-5 h-5 text-green-500 mt-0.5 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <div>
                          <h5 className="font-medium text-gray-900">Credential Management</h5>
                          <p className="text-sm text-gray-600 mt-1">
                            For security, prefer using system-managed credentials when possible. Only provide custom credentials when necessary.
                          </p>
                        </div>
                      </div>
                      
                      <div className="flex items-start">
                        <svg className="w-5 h-5 text-green-500 mt-0.5 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <div>
                          <h5 className="font-medium text-gray-900">File Processing</h5>
                          <p className="text-sm text-gray-600 mt-1">
                            Downloaded 835 files are automatically uploaded to the RCM system and processed. Check the result field for processing details.
                          </p>
                        </div>
                      </div>
                      
                      <div className="flex items-start">
                        <svg className="w-5 h-5 text-green-500 mt-0.5 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <div>
                          <h5 className="font-medium text-gray-900">Rate Limiting</h5>
                          <p className="text-sm text-gray-600 mt-1">
                            Avoid creating multiple scrapers simultaneously for the same payer to prevent rate limiting and account lockouts.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="mt-6 flex justify-end">
                <Button 
                  onClick={() => setIsApiDocsModalOpen(false)}
                  className="!bg-gray-500"
                >
                  Close Documentation
                </Button>
              </div>
            </div>
          </Card>
        </div>
      )}
    </div>
  );
};

export default TryItOut;
